import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  date: any;
  json: any;
  numeric: any;
  timestamptz: any;
  timetz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "checkin.checkin" */
export type Checkin = {
  __typename?: 'checkin';
  /** An array relationship */
  checkinCustomers: Array<CheckinCustomer>;
  /** An aggregate relationship */
  checkinCustomers_aggregate: CheckinCustomer_Aggregate;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "checkin.checkin" */
export type CheckinCheckinCustomersArgs = {
  distinct_on?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CheckinCustomer_Order_By>>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};


/** columns and relationships of "checkin.checkin" */
export type CheckinCheckinCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CheckinCustomer_Order_By>>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};

/** columns and relationships of "checkin.checkin_customer" */
export type CheckinCustomer = {
  __typename?: 'checkinCustomer';
  address?: Maybe<Scalars['String']>;
  addressOcr?: Maybe<Scalars['String']>;
  backPageType?: Maybe<Scalars['String']>;
  /** An object relationship */
  checkin?: Maybe<Checkin>;
  checkinId?: Maybe<Scalars['uuid']>;
  checkinNumber?: Maybe<Scalars['String']>;
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
  confirmedAt?: Maybe<Scalars['timetz']>;
  createdAt: Scalars['timestamptz'];
  cuttedBackPagePath?: Maybe<Scalars['String']>;
  cuttedFrontPagePath?: Maybe<Scalars['String']>;
  dateOfArrival?: Maybe<Scalars['date']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  dateOfBirthOcr?: Maybe<Scalars['date']>;
  dateOfExpiry?: Maybe<Scalars['date']>;
  dateOfExpiryOcr?: Maybe<Scalars['date']>;
  dateOfIssue?: Maybe<Scalars['date']>;
  debugApiResponseBackPage?: Maybe<Scalars['json']>;
  debugApiResponseFrontPage?: Maybe<Scalars['json']>;
  debugApiUploadBackPage?: Maybe<Scalars['json']>;
  debugApiUploadFrontPage?: Maybe<Scalars['json']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentNumberOcr?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  frontPageType?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameOcr?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isConfirmed: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isOcrDone: Scalars['Boolean'];
  isProcessed: Scalars['Boolean'];
  isScanDone: Scalars['Boolean'];
  nationality?: Maybe<Scalars['String']>;
  nationalityOcr?: Maybe<Scalars['String']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  personalNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  surnameOcr?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  uploadedBackPagePath?: Maybe<Scalars['String']>;
  uploadedFrontPagePath?: Maybe<Scalars['String']>;
};


/** columns and relationships of "checkin.checkin_customer" */
export type CheckinCustomerDebugApiResponseBackPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "checkin.checkin_customer" */
export type CheckinCustomerDebugApiResponseFrontPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "checkin.checkin_customer" */
export type CheckinCustomerDebugApiUploadBackPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "checkin.checkin_customer" */
export type CheckinCustomerDebugApiUploadFrontPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "checkin.checkin_customer" */
export type CheckinCustomerNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "checkin.checkin_customer" */
export type CheckinCustomerNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** aggregated selection of "checkin.checkin_customer" */
export type CheckinCustomer_Aggregate = {
  __typename?: 'checkinCustomer_aggregate';
  aggregate?: Maybe<CheckinCustomer_Aggregate_Fields>;
  nodes: Array<CheckinCustomer>;
};

export type CheckinCustomer_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<CheckinCustomer_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<CheckinCustomer_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<CheckinCustomer_Aggregate_Bool_Exp_Count>;
};

export type CheckinCustomer_Aggregate_Bool_Exp_Bool_And = {
  arguments: CheckinCustomer_Select_Column_CheckinCustomer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CheckinCustomer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CheckinCustomer_Aggregate_Bool_Exp_Bool_Or = {
  arguments: CheckinCustomer_Select_Column_CheckinCustomer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CheckinCustomer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CheckinCustomer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CheckinCustomer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "checkin.checkin_customer" */
export type CheckinCustomer_Aggregate_Fields = {
  __typename?: 'checkinCustomer_aggregate_fields';
  avg?: Maybe<CheckinCustomer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CheckinCustomer_Max_Fields>;
  min?: Maybe<CheckinCustomer_Min_Fields>;
  stddev?: Maybe<CheckinCustomer_Stddev_Fields>;
  stddev_pop?: Maybe<CheckinCustomer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CheckinCustomer_Stddev_Samp_Fields>;
  sum?: Maybe<CheckinCustomer_Sum_Fields>;
  var_pop?: Maybe<CheckinCustomer_Var_Pop_Fields>;
  var_samp?: Maybe<CheckinCustomer_Var_Samp_Fields>;
  variance?: Maybe<CheckinCustomer_Variance_Fields>;
};


/** aggregate fields of "checkin.checkin_customer" */
export type CheckinCustomer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "checkin.checkin_customer" */
export type CheckinCustomer_Aggregate_Order_By = {
  avg?: InputMaybe<CheckinCustomer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CheckinCustomer_Max_Order_By>;
  min?: InputMaybe<CheckinCustomer_Min_Order_By>;
  stddev?: InputMaybe<CheckinCustomer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CheckinCustomer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CheckinCustomer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CheckinCustomer_Sum_Order_By>;
  var_pop?: InputMaybe<CheckinCustomer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CheckinCustomer_Var_Samp_Order_By>;
  variance?: InputMaybe<CheckinCustomer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "checkin.checkin_customer" */
export type CheckinCustomer_Arr_Rel_Insert_Input = {
  data: Array<CheckinCustomer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CheckinCustomer_On_Conflict>;
};

/** aggregate avg on columns */
export type CheckinCustomer_Avg_Fields = {
  __typename?: 'checkinCustomer_avg_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Avg_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "checkin.checkin_customer". All fields are combined with a logical 'AND'. */
export type CheckinCustomer_Bool_Exp = {
  _and?: InputMaybe<Array<CheckinCustomer_Bool_Exp>>;
  _not?: InputMaybe<CheckinCustomer_Bool_Exp>;
  _or?: InputMaybe<Array<CheckinCustomer_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  addressOcr?: InputMaybe<String_Comparison_Exp>;
  backPageType?: InputMaybe<String_Comparison_Exp>;
  checkin?: InputMaybe<Checkin_Bool_Exp>;
  checkinId?: InputMaybe<Uuid_Comparison_Exp>;
  checkinNumber?: InputMaybe<String_Comparison_Exp>;
  confidenceApiResponseBackPage?: InputMaybe<Numeric_Comparison_Exp>;
  confidenceApiResponseFrontPage?: InputMaybe<Numeric_Comparison_Exp>;
  confirmedAt?: InputMaybe<Timetz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cuttedBackPagePath?: InputMaybe<String_Comparison_Exp>;
  cuttedFrontPagePath?: InputMaybe<String_Comparison_Exp>;
  dateOfArrival?: InputMaybe<Date_Comparison_Exp>;
  dateOfBirth?: InputMaybe<Date_Comparison_Exp>;
  dateOfBirthOcr?: InputMaybe<Date_Comparison_Exp>;
  dateOfExpiry?: InputMaybe<Date_Comparison_Exp>;
  dateOfExpiryOcr?: InputMaybe<Date_Comparison_Exp>;
  dateOfIssue?: InputMaybe<Date_Comparison_Exp>;
  debugApiResponseBackPage?: InputMaybe<Json_Comparison_Exp>;
  debugApiResponseFrontPage?: InputMaybe<Json_Comparison_Exp>;
  debugApiUploadBackPage?: InputMaybe<Json_Comparison_Exp>;
  debugApiUploadFrontPage?: InputMaybe<Json_Comparison_Exp>;
  documentNumber?: InputMaybe<String_Comparison_Exp>;
  documentNumberOcr?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  frontPageType?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  givenName?: InputMaybe<String_Comparison_Exp>;
  givenNameOcr?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isConfirmed?: InputMaybe<Boolean_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  isOcrDone?: InputMaybe<Boolean_Comparison_Exp>;
  isProcessed?: InputMaybe<Boolean_Comparison_Exp>;
  isScanDone?: InputMaybe<Boolean_Comparison_Exp>;
  nationality?: InputMaybe<String_Comparison_Exp>;
  nationalityOcr?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  personalNumber?: InputMaybe<String_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  surname?: InputMaybe<String_Comparison_Exp>;
  surnameOcr?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedBackPagePath?: InputMaybe<String_Comparison_Exp>;
  uploadedFrontPagePath?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkin.checkin_customer" */
export enum CheckinCustomer_Constraint {
  /** unique or primary key constraint on columns "checkin_number" */
  CheckinCustomerCheckinNumberKey = 'checkin_customer_checkin_number_key',
  /** unique or primary key constraint on columns "id" */
  CheckinCustomerIdKey = 'checkin_customer_id_key',
  /** unique or primary key constraint on columns "id" */
  CheckinCustomerPkey = 'checkin_customer_pkey'
}

/** input type for incrementing numeric columns in table "checkin.checkin_customer" */
export type CheckinCustomer_Inc_Input = {
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "checkin.checkin_customer" */
export type CheckinCustomer_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressOcr?: InputMaybe<Scalars['String']>;
  backPageType?: InputMaybe<Scalars['String']>;
  checkin?: InputMaybe<Checkin_Obj_Rel_Insert_Input>;
  checkinId?: InputMaybe<Scalars['uuid']>;
  checkinNumber?: InputMaybe<Scalars['String']>;
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
  confirmedAt?: InputMaybe<Scalars['timetz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: InputMaybe<Scalars['String']>;
  cuttedFrontPagePath?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['date']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  dateOfBirthOcr?: InputMaybe<Scalars['date']>;
  dateOfExpiry?: InputMaybe<Scalars['date']>;
  dateOfExpiryOcr?: InputMaybe<Scalars['date']>;
  dateOfIssue?: InputMaybe<Scalars['date']>;
  debugApiResponseBackPage?: InputMaybe<Scalars['json']>;
  debugApiResponseFrontPage?: InputMaybe<Scalars['json']>;
  debugApiUploadBackPage?: InputMaybe<Scalars['json']>;
  debugApiUploadFrontPage?: InputMaybe<Scalars['json']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentNumberOcr?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  frontPageType?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  givenNameOcr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isOcrDone?: InputMaybe<Scalars['Boolean']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isScanDone?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<Scalars['String']>;
  nationalityOcr?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Notifications_Arr_Rel_Insert_Input>;
  personalNumber?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  surnameOcr?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: InputMaybe<Scalars['String']>;
  uploadedFrontPagePath?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CheckinCustomer_Max_Fields = {
  __typename?: 'checkinCustomer_max_fields';
  address?: Maybe<Scalars['String']>;
  addressOcr?: Maybe<Scalars['String']>;
  backPageType?: Maybe<Scalars['String']>;
  checkinId?: Maybe<Scalars['uuid']>;
  checkinNumber?: Maybe<Scalars['String']>;
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
  confirmedAt?: Maybe<Scalars['timetz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: Maybe<Scalars['String']>;
  cuttedFrontPagePath?: Maybe<Scalars['String']>;
  dateOfArrival?: Maybe<Scalars['date']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  dateOfBirthOcr?: Maybe<Scalars['date']>;
  dateOfExpiry?: Maybe<Scalars['date']>;
  dateOfExpiryOcr?: Maybe<Scalars['date']>;
  dateOfIssue?: Maybe<Scalars['date']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentNumberOcr?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  frontPageType?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameOcr?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nationality?: Maybe<Scalars['String']>;
  nationalityOcr?: Maybe<Scalars['String']>;
  personalNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  surnameOcr?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: Maybe<Scalars['String']>;
  uploadedFrontPagePath?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  addressOcr?: InputMaybe<Order_By>;
  backPageType?: InputMaybe<Order_By>;
  checkinId?: InputMaybe<Order_By>;
  checkinNumber?: InputMaybe<Order_By>;
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttedBackPagePath?: InputMaybe<Order_By>;
  cuttedFrontPagePath?: InputMaybe<Order_By>;
  dateOfArrival?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  dateOfBirthOcr?: InputMaybe<Order_By>;
  dateOfExpiry?: InputMaybe<Order_By>;
  dateOfExpiryOcr?: InputMaybe<Order_By>;
  dateOfIssue?: InputMaybe<Order_By>;
  documentNumber?: InputMaybe<Order_By>;
  documentNumberOcr?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  frontPageType?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  givenNameOcr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  nationalityOcr?: InputMaybe<Order_By>;
  personalNumber?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  surname?: InputMaybe<Order_By>;
  surnameOcr?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedBackPagePath?: InputMaybe<Order_By>;
  uploadedFrontPagePath?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CheckinCustomer_Min_Fields = {
  __typename?: 'checkinCustomer_min_fields';
  address?: Maybe<Scalars['String']>;
  addressOcr?: Maybe<Scalars['String']>;
  backPageType?: Maybe<Scalars['String']>;
  checkinId?: Maybe<Scalars['uuid']>;
  checkinNumber?: Maybe<Scalars['String']>;
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
  confirmedAt?: Maybe<Scalars['timetz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: Maybe<Scalars['String']>;
  cuttedFrontPagePath?: Maybe<Scalars['String']>;
  dateOfArrival?: Maybe<Scalars['date']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  dateOfBirthOcr?: Maybe<Scalars['date']>;
  dateOfExpiry?: Maybe<Scalars['date']>;
  dateOfExpiryOcr?: Maybe<Scalars['date']>;
  dateOfIssue?: Maybe<Scalars['date']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentNumberOcr?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  frontPageType?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameOcr?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nationality?: Maybe<Scalars['String']>;
  nationalityOcr?: Maybe<Scalars['String']>;
  personalNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  surnameOcr?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: Maybe<Scalars['String']>;
  uploadedFrontPagePath?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  addressOcr?: InputMaybe<Order_By>;
  backPageType?: InputMaybe<Order_By>;
  checkinId?: InputMaybe<Order_By>;
  checkinNumber?: InputMaybe<Order_By>;
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttedBackPagePath?: InputMaybe<Order_By>;
  cuttedFrontPagePath?: InputMaybe<Order_By>;
  dateOfArrival?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  dateOfBirthOcr?: InputMaybe<Order_By>;
  dateOfExpiry?: InputMaybe<Order_By>;
  dateOfExpiryOcr?: InputMaybe<Order_By>;
  dateOfIssue?: InputMaybe<Order_By>;
  documentNumber?: InputMaybe<Order_By>;
  documentNumberOcr?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  frontPageType?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  givenNameOcr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  nationalityOcr?: InputMaybe<Order_By>;
  personalNumber?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  surname?: InputMaybe<Order_By>;
  surnameOcr?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedBackPagePath?: InputMaybe<Order_By>;
  uploadedFrontPagePath?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "checkin.checkin_customer" */
export type CheckinCustomer_Mutation_Response = {
  __typename?: 'checkinCustomer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CheckinCustomer>;
};

/** input type for inserting object relation for remote table "checkin.checkin_customer" */
export type CheckinCustomer_Obj_Rel_Insert_Input = {
  data: CheckinCustomer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CheckinCustomer_On_Conflict>;
};

/** on_conflict condition type for table "checkin.checkin_customer" */
export type CheckinCustomer_On_Conflict = {
  constraint: CheckinCustomer_Constraint;
  update_columns?: Array<CheckinCustomer_Update_Column>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};

/** Ordering options when selecting data from "checkin.checkin_customer". */
export type CheckinCustomer_Order_By = {
  address?: InputMaybe<Order_By>;
  addressOcr?: InputMaybe<Order_By>;
  backPageType?: InputMaybe<Order_By>;
  checkin?: InputMaybe<Checkin_Order_By>;
  checkinId?: InputMaybe<Order_By>;
  checkinNumber?: InputMaybe<Order_By>;
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttedBackPagePath?: InputMaybe<Order_By>;
  cuttedFrontPagePath?: InputMaybe<Order_By>;
  dateOfArrival?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  dateOfBirthOcr?: InputMaybe<Order_By>;
  dateOfExpiry?: InputMaybe<Order_By>;
  dateOfExpiryOcr?: InputMaybe<Order_By>;
  dateOfIssue?: InputMaybe<Order_By>;
  debugApiResponseBackPage?: InputMaybe<Order_By>;
  debugApiResponseFrontPage?: InputMaybe<Order_By>;
  debugApiUploadBackPage?: InputMaybe<Order_By>;
  debugApiUploadFrontPage?: InputMaybe<Order_By>;
  documentNumber?: InputMaybe<Order_By>;
  documentNumberOcr?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  frontPageType?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  givenNameOcr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isConfirmed?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  isOcrDone?: InputMaybe<Order_By>;
  isProcessed?: InputMaybe<Order_By>;
  isScanDone?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  nationalityOcr?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  personalNumber?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  surname?: InputMaybe<Order_By>;
  surnameOcr?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedBackPagePath?: InputMaybe<Order_By>;
  uploadedFrontPagePath?: InputMaybe<Order_By>;
};

/** primary key columns input for table: checkin.checkin_customer */
export type CheckinCustomer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "checkin.checkin_customer" */
export enum CheckinCustomer_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressOcr = 'addressOcr',
  /** column name */
  BackPageType = 'backPageType',
  /** column name */
  CheckinId = 'checkinId',
  /** column name */
  CheckinNumber = 'checkinNumber',
  /** column name */
  ConfidenceApiResponseBackPage = 'confidenceApiResponseBackPage',
  /** column name */
  ConfidenceApiResponseFrontPage = 'confidenceApiResponseFrontPage',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CuttedBackPagePath = 'cuttedBackPagePath',
  /** column name */
  CuttedFrontPagePath = 'cuttedFrontPagePath',
  /** column name */
  DateOfArrival = 'dateOfArrival',
  /** column name */
  DateOfBirth = 'dateOfBirth',
  /** column name */
  DateOfBirthOcr = 'dateOfBirthOcr',
  /** column name */
  DateOfExpiry = 'dateOfExpiry',
  /** column name */
  DateOfExpiryOcr = 'dateOfExpiryOcr',
  /** column name */
  DateOfIssue = 'dateOfIssue',
  /** column name */
  DebugApiResponseBackPage = 'debugApiResponseBackPage',
  /** column name */
  DebugApiResponseFrontPage = 'debugApiResponseFrontPage',
  /** column name */
  DebugApiUploadBackPage = 'debugApiUploadBackPage',
  /** column name */
  DebugApiUploadFrontPage = 'debugApiUploadFrontPage',
  /** column name */
  DocumentNumber = 'documentNumber',
  /** column name */
  DocumentNumberOcr = 'documentNumberOcr',
  /** column name */
  DocumentType = 'documentType',
  /** column name */
  Email = 'email',
  /** column name */
  FrontPageType = 'frontPageType',
  /** column name */
  Gender = 'gender',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  GivenNameOcr = 'givenNameOcr',
  /** column name */
  Id = 'id',
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsProcessed = 'isProcessed',
  /** column name */
  IsScanDone = 'isScanDone',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  NationalityOcr = 'nationalityOcr',
  /** column name */
  PersonalNumber = 'personalNumber',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Surname = 'surname',
  /** column name */
  SurnameOcr = 'surnameOcr',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedBackPagePath = 'uploadedBackPagePath',
  /** column name */
  UploadedFrontPagePath = 'uploadedFrontPagePath'
}

/** select "checkinCustomer_aggregate_bool_exp_bool_and_arguments_columns" columns of table "checkin.checkin_customer" */
export enum CheckinCustomer_Select_Column_CheckinCustomer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsProcessed = 'isProcessed',
  /** column name */
  IsScanDone = 'isScanDone'
}

/** select "checkinCustomer_aggregate_bool_exp_bool_or_arguments_columns" columns of table "checkin.checkin_customer" */
export enum CheckinCustomer_Select_Column_CheckinCustomer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsProcessed = 'isProcessed',
  /** column name */
  IsScanDone = 'isScanDone'
}

/** input type for updating data in table "checkin.checkin_customer" */
export type CheckinCustomer_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressOcr?: InputMaybe<Scalars['String']>;
  backPageType?: InputMaybe<Scalars['String']>;
  checkinId?: InputMaybe<Scalars['uuid']>;
  checkinNumber?: InputMaybe<Scalars['String']>;
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
  confirmedAt?: InputMaybe<Scalars['timetz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: InputMaybe<Scalars['String']>;
  cuttedFrontPagePath?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['date']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  dateOfBirthOcr?: InputMaybe<Scalars['date']>;
  dateOfExpiry?: InputMaybe<Scalars['date']>;
  dateOfExpiryOcr?: InputMaybe<Scalars['date']>;
  dateOfIssue?: InputMaybe<Scalars['date']>;
  debugApiResponseBackPage?: InputMaybe<Scalars['json']>;
  debugApiResponseFrontPage?: InputMaybe<Scalars['json']>;
  debugApiUploadBackPage?: InputMaybe<Scalars['json']>;
  debugApiUploadFrontPage?: InputMaybe<Scalars['json']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentNumberOcr?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  frontPageType?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  givenNameOcr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isOcrDone?: InputMaybe<Scalars['Boolean']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isScanDone?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<Scalars['String']>;
  nationalityOcr?: InputMaybe<Scalars['String']>;
  personalNumber?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  surnameOcr?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: InputMaybe<Scalars['String']>;
  uploadedFrontPagePath?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CheckinCustomer_Stddev_Fields = {
  __typename?: 'checkinCustomer_stddev_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Stddev_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CheckinCustomer_Stddev_Pop_Fields = {
  __typename?: 'checkinCustomer_stddev_pop_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Stddev_Pop_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CheckinCustomer_Stddev_Samp_Fields = {
  __typename?: 'checkinCustomer_stddev_samp_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Stddev_Samp_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "checkinCustomer" */
export type CheckinCustomer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CheckinCustomer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CheckinCustomer_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressOcr?: InputMaybe<Scalars['String']>;
  backPageType?: InputMaybe<Scalars['String']>;
  checkinId?: InputMaybe<Scalars['uuid']>;
  checkinNumber?: InputMaybe<Scalars['String']>;
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
  confirmedAt?: InputMaybe<Scalars['timetz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: InputMaybe<Scalars['String']>;
  cuttedFrontPagePath?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['date']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  dateOfBirthOcr?: InputMaybe<Scalars['date']>;
  dateOfExpiry?: InputMaybe<Scalars['date']>;
  dateOfExpiryOcr?: InputMaybe<Scalars['date']>;
  dateOfIssue?: InputMaybe<Scalars['date']>;
  debugApiResponseBackPage?: InputMaybe<Scalars['json']>;
  debugApiResponseFrontPage?: InputMaybe<Scalars['json']>;
  debugApiUploadBackPage?: InputMaybe<Scalars['json']>;
  debugApiUploadFrontPage?: InputMaybe<Scalars['json']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentNumberOcr?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  frontPageType?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  givenNameOcr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isOcrDone?: InputMaybe<Scalars['Boolean']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isScanDone?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<Scalars['String']>;
  nationalityOcr?: InputMaybe<Scalars['String']>;
  personalNumber?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  surnameOcr?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: InputMaybe<Scalars['String']>;
  uploadedFrontPagePath?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CheckinCustomer_Sum_Fields = {
  __typename?: 'checkinCustomer_sum_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Sum_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** update columns of table "checkin.checkin_customer" */
export enum CheckinCustomer_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressOcr = 'addressOcr',
  /** column name */
  BackPageType = 'backPageType',
  /** column name */
  CheckinId = 'checkinId',
  /** column name */
  CheckinNumber = 'checkinNumber',
  /** column name */
  ConfidenceApiResponseBackPage = 'confidenceApiResponseBackPage',
  /** column name */
  ConfidenceApiResponseFrontPage = 'confidenceApiResponseFrontPage',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CuttedBackPagePath = 'cuttedBackPagePath',
  /** column name */
  CuttedFrontPagePath = 'cuttedFrontPagePath',
  /** column name */
  DateOfArrival = 'dateOfArrival',
  /** column name */
  DateOfBirth = 'dateOfBirth',
  /** column name */
  DateOfBirthOcr = 'dateOfBirthOcr',
  /** column name */
  DateOfExpiry = 'dateOfExpiry',
  /** column name */
  DateOfExpiryOcr = 'dateOfExpiryOcr',
  /** column name */
  DateOfIssue = 'dateOfIssue',
  /** column name */
  DebugApiResponseBackPage = 'debugApiResponseBackPage',
  /** column name */
  DebugApiResponseFrontPage = 'debugApiResponseFrontPage',
  /** column name */
  DebugApiUploadBackPage = 'debugApiUploadBackPage',
  /** column name */
  DebugApiUploadFrontPage = 'debugApiUploadFrontPage',
  /** column name */
  DocumentNumber = 'documentNumber',
  /** column name */
  DocumentNumberOcr = 'documentNumberOcr',
  /** column name */
  DocumentType = 'documentType',
  /** column name */
  Email = 'email',
  /** column name */
  FrontPageType = 'frontPageType',
  /** column name */
  Gender = 'gender',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  GivenNameOcr = 'givenNameOcr',
  /** column name */
  Id = 'id',
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsProcessed = 'isProcessed',
  /** column name */
  IsScanDone = 'isScanDone',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  NationalityOcr = 'nationalityOcr',
  /** column name */
  PersonalNumber = 'personalNumber',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Surname = 'surname',
  /** column name */
  SurnameOcr = 'surnameOcr',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedBackPagePath = 'uploadedBackPagePath',
  /** column name */
  UploadedFrontPagePath = 'uploadedFrontPagePath'
}

export type CheckinCustomer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CheckinCustomer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CheckinCustomer_Set_Input>;
  /** filter the rows which have to be updated */
  where: CheckinCustomer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CheckinCustomer_Var_Pop_Fields = {
  __typename?: 'checkinCustomer_var_pop_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Var_Pop_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CheckinCustomer_Var_Samp_Fields = {
  __typename?: 'checkinCustomer_var_samp_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Var_Samp_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CheckinCustomer_Variance_Fields = {
  __typename?: 'checkinCustomer_variance_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "checkin.checkin_customer" */
export type CheckinCustomer_Variance_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregated selection of "checkin.checkin" */
export type Checkin_Aggregate = {
  __typename?: 'checkin_aggregate';
  aggregate?: Maybe<Checkin_Aggregate_Fields>;
  nodes: Array<Checkin>;
};

export type Checkin_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Checkin_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Checkin_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Checkin_Aggregate_Bool_Exp_Count>;
};

export type Checkin_Aggregate_Bool_Exp_Bool_And = {
  arguments: Checkin_Select_Column_Checkin_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkin_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Checkin_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Checkin_Select_Column_Checkin_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkin_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Checkin_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Checkin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Checkin_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "checkin.checkin" */
export type Checkin_Aggregate_Fields = {
  __typename?: 'checkin_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Checkin_Max_Fields>;
  min?: Maybe<Checkin_Min_Fields>;
};


/** aggregate fields of "checkin.checkin" */
export type Checkin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Checkin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "checkin.checkin" */
export type Checkin_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Checkin_Max_Order_By>;
  min?: InputMaybe<Checkin_Min_Order_By>;
};

/** input type for inserting array relation for remote table "checkin.checkin" */
export type Checkin_Arr_Rel_Insert_Input = {
  data: Array<Checkin_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Checkin_On_Conflict>;
};

/** Boolean expression to filter rows from the table "checkin.checkin". All fields are combined with a logical 'AND'. */
export type Checkin_Bool_Exp = {
  _and?: InputMaybe<Array<Checkin_Bool_Exp>>;
  _not?: InputMaybe<Checkin_Bool_Exp>;
  _or?: InputMaybe<Array<Checkin_Bool_Exp>>;
  checkinCustomers?: InputMaybe<CheckinCustomer_Bool_Exp>;
  checkinCustomers_aggregate?: InputMaybe<CheckinCustomer_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkin.checkin" */
export enum Checkin_Constraint {
  /** unique or primary key constraint on columns "id" */
  CheckinPkey = 'checkin_pkey'
}

/** input type for inserting data into table "checkin.checkin" */
export type Checkin_Insert_Input = {
  checkinCustomers?: InputMaybe<CheckinCustomer_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Checkin_Max_Fields = {
  __typename?: 'checkin_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organizationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "checkin.checkin" */
export type Checkin_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Checkin_Min_Fields = {
  __typename?: 'checkin_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organizationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "checkin.checkin" */
export type Checkin_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "checkin.checkin" */
export type Checkin_Mutation_Response = {
  __typename?: 'checkin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Checkin>;
};

/** input type for inserting object relation for remote table "checkin.checkin" */
export type Checkin_Obj_Rel_Insert_Input = {
  data: Checkin_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Checkin_On_Conflict>;
};

/** on_conflict condition type for table "checkin.checkin" */
export type Checkin_On_Conflict = {
  constraint: Checkin_Constraint;
  update_columns?: Array<Checkin_Update_Column>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};

/** Ordering options when selecting data from "checkin.checkin". */
export type Checkin_Order_By = {
  checkinCustomers_aggregate?: InputMaybe<CheckinCustomer_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: checkin.checkin */
export type Checkin_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "checkin.checkin" */
export enum Checkin_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "checkin_aggregate_bool_exp_bool_and_arguments_columns" columns of table "checkin.checkin" */
export enum Checkin_Select_Column_Checkin_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** select "checkin_aggregate_bool_exp_bool_or_arguments_columns" columns of table "checkin.checkin" */
export enum Checkin_Select_Column_Checkin_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** input type for updating data in table "checkin.checkin" */
export type Checkin_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "checkin" */
export type Checkin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Checkin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Checkin_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "checkin.checkin" */
export enum Checkin_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Checkin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Checkin_Set_Input>;
  /** filter the rows which have to be updated */
  where: Checkin_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "dot.checkin" */
export type DotCheckin = {
  __typename?: 'dotCheckin';
  /** An array relationship */
  checkinAnonymousLinks: Array<DotCheckinAnonymousLink>;
  /** An aggregate relationship */
  checkinAnonymousLinks_aggregate: DotCheckinAnonymousLink_Aggregate;
  createdAt?: Maybe<Scalars['timestamptz']>;
  hotelEmail: Scalars['String'];
  id: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "dot.checkin" */
export type DotCheckinCheckinAnonymousLinksArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinAnonymousLink_Order_By>>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};


/** columns and relationships of "dot.checkin" */
export type DotCheckinCheckinAnonymousLinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinAnonymousLink_Order_By>>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};

/** columns and relationships of "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink = {
  __typename?: 'dotCheckinAnonymousLink';
  /** An object relationship */
  checkin: DotCheckin;
  /** An array relationship */
  checkinCustomers: Array<DotCheckinCustomer>;
  /** An aggregate relationship */
  checkinCustomers_aggregate: DotCheckinCustomer_Aggregate;
  checkinId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  hotelEmail?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  /** Computed field to calculate is expired */
  isExpired?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLinkCheckinCustomersArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinCustomer_Order_By>>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};


/** columns and relationships of "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLinkCheckinCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinCustomer_Order_By>>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};

/** aggregated selection of "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Aggregate = {
  __typename?: 'dotCheckinAnonymousLink_aggregate';
  aggregate?: Maybe<DotCheckinAnonymousLink_Aggregate_Fields>;
  nodes: Array<DotCheckinAnonymousLink>;
};

export type DotCheckinAnonymousLink_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<DotCheckinAnonymousLink_Aggregate_Bool_Exp_Count>;
};

export type DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_And = {
  arguments: DotCheckinAnonymousLink_Select_Column_DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_Or = {
  arguments: DotCheckinAnonymousLink_Select_Column_DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type DotCheckinAnonymousLink_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Aggregate_Fields = {
  __typename?: 'dotCheckinAnonymousLink_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DotCheckinAnonymousLink_Max_Fields>;
  min?: Maybe<DotCheckinAnonymousLink_Min_Fields>;
};


/** aggregate fields of "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DotCheckinAnonymousLink_Max_Order_By>;
  min?: InputMaybe<DotCheckinAnonymousLink_Min_Order_By>;
};

/** input type for inserting array relation for remote table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Arr_Rel_Insert_Input = {
  data: Array<DotCheckinAnonymousLink_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<DotCheckinAnonymousLink_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dot.checkin_anonymous_link". All fields are combined with a logical 'AND'. */
export type DotCheckinAnonymousLink_Bool_Exp = {
  _and?: InputMaybe<Array<DotCheckinAnonymousLink_Bool_Exp>>;
  _not?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
  _or?: InputMaybe<Array<DotCheckinAnonymousLink_Bool_Exp>>;
  checkin?: InputMaybe<DotCheckin_Bool_Exp>;
  checkinCustomers?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
  checkinCustomers_aggregate?: InputMaybe<DotCheckinCustomer_Aggregate_Bool_Exp>;
  checkinId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  hotelEmail?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  isExpired?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dot.checkin_anonymous_link" */
export enum DotCheckinAnonymousLink_Constraint {
  /** unique or primary key constraint on columns "id" */
  CheckinAnonymousLinkPkey = 'checkin_anonymous_link_pkey'
}

/** input type for inserting data into table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Insert_Input = {
  checkin?: InputMaybe<DotCheckin_Obj_Rel_Insert_Input>;
  checkinCustomers?: InputMaybe<DotCheckinCustomer_Arr_Rel_Insert_Input>;
  checkinId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  hotelEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DotCheckinAnonymousLink_Max_Fields = {
  __typename?: 'dotCheckinAnonymousLink_max_fields';
  checkinId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  hotelEmail?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Max_Order_By = {
  checkinId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  hotelEmail?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type DotCheckinAnonymousLink_Min_Fields = {
  __typename?: 'dotCheckinAnonymousLink_min_fields';
  checkinId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  hotelEmail?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Min_Order_By = {
  checkinId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  hotelEmail?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Mutation_Response = {
  __typename?: 'dotCheckinAnonymousLink_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DotCheckinAnonymousLink>;
};

/** input type for inserting object relation for remote table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Obj_Rel_Insert_Input = {
  data: DotCheckinAnonymousLink_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DotCheckinAnonymousLink_On_Conflict>;
};

/** on_conflict condition type for table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_On_Conflict = {
  constraint: DotCheckinAnonymousLink_Constraint;
  update_columns?: Array<DotCheckinAnonymousLink_Update_Column>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};

/** Ordering options when selecting data from "dot.checkin_anonymous_link". */
export type DotCheckinAnonymousLink_Order_By = {
  checkin?: InputMaybe<DotCheckin_Order_By>;
  checkinCustomers_aggregate?: InputMaybe<DotCheckinCustomer_Aggregate_Order_By>;
  checkinId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  hotelEmail?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  isExpired?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dot.checkin_anonymous_link */
export type DotCheckinAnonymousLink_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "dot.checkin_anonymous_link" */
export enum DotCheckinAnonymousLink_Select_Column {
  /** column name */
  CheckinId = 'checkinId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  HotelEmail = 'hotelEmail',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "dotCheckinAnonymousLink_aggregate_bool_exp_bool_and_arguments_columns" columns of table "dot.checkin_anonymous_link" */
export enum DotCheckinAnonymousLink_Select_Column_DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** select "dotCheckinAnonymousLink_aggregate_bool_exp_bool_or_arguments_columns" columns of table "dot.checkin_anonymous_link" */
export enum DotCheckinAnonymousLink_Select_Column_DotCheckinAnonymousLink_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** input type for updating data in table "dot.checkin_anonymous_link" */
export type DotCheckinAnonymousLink_Set_Input = {
  checkinId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  hotelEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "dotCheckinAnonymousLink" */
export type DotCheckinAnonymousLink_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DotCheckinAnonymousLink_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DotCheckinAnonymousLink_Stream_Cursor_Value_Input = {
  checkinId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  hotelEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "dot.checkin_anonymous_link" */
export enum DotCheckinAnonymousLink_Update_Column {
  /** column name */
  CheckinId = 'checkinId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  HotelEmail = 'hotelEmail',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DotCheckinAnonymousLink_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DotCheckinAnonymousLink_Set_Input>;
  /** filter the rows which have to be updated */
  where: DotCheckinAnonymousLink_Bool_Exp;
};

/** columns and relationships of "dot.checkin_customer" */
export type DotCheckinCustomer = {
  __typename?: 'dotCheckinCustomer';
  address?: Maybe<Scalars['String']>;
  addressOcr?: Maybe<Scalars['String']>;
  backPageType?: Maybe<Scalars['String']>;
  /** An object relationship */
  checkinAnonymousLink?: Maybe<DotCheckinAnonymousLink>;
  checkinAnonymousLinkId?: Maybe<Scalars['uuid']>;
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  cuttedBackPagePath?: Maybe<Scalars['String']>;
  cuttedFrontPagePath?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  dateOfBirthOcr?: Maybe<Scalars['date']>;
  dateOfExpiry?: Maybe<Scalars['date']>;
  dateOfExpiryOcr?: Maybe<Scalars['date']>;
  dateOfIssue?: Maybe<Scalars['date']>;
  debugApiResponseBackPage?: Maybe<Scalars['json']>;
  debugApiResponseFrontPage?: Maybe<Scalars['json']>;
  debugApiUploadBackPage?: Maybe<Scalars['json']>;
  debugApiUploadFrontPage?: Maybe<Scalars['json']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentNumberOcr?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['json']>;
  frontPageType?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameOcr?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isConfirmed: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isOcrDone: Scalars['Boolean'];
  isScanDone?: Maybe<Scalars['Boolean']>;
  nationality?: Maybe<Scalars['String']>;
  nationalityOcr?: Maybe<Scalars['String']>;
  personalNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  surnameOcr?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  uploadedBackPagePath?: Maybe<Scalars['String']>;
  uploadedFrontPagePath?: Maybe<Scalars['String']>;
};


/** columns and relationships of "dot.checkin_customer" */
export type DotCheckinCustomerDebugApiResponseBackPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dot.checkin_customer" */
export type DotCheckinCustomerDebugApiResponseFrontPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dot.checkin_customer" */
export type DotCheckinCustomerDebugApiUploadBackPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dot.checkin_customer" */
export type DotCheckinCustomerDebugApiUploadFrontPageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dot.checkin_customer" */
export type DotCheckinCustomerDocumentTypeArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "dot.checkin_customer" */
export type DotCheckinCustomer_Aggregate = {
  __typename?: 'dotCheckinCustomer_aggregate';
  aggregate?: Maybe<DotCheckinCustomer_Aggregate_Fields>;
  nodes: Array<DotCheckinCustomer>;
};

export type DotCheckinCustomer_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<DotCheckinCustomer_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<DotCheckinCustomer_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<DotCheckinCustomer_Aggregate_Bool_Exp_Count>;
};

export type DotCheckinCustomer_Aggregate_Bool_Exp_Bool_And = {
  arguments: DotCheckinCustomer_Select_Column_DotCheckinCustomer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type DotCheckinCustomer_Aggregate_Bool_Exp_Bool_Or = {
  arguments: DotCheckinCustomer_Select_Column_DotCheckinCustomer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type DotCheckinCustomer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dot.checkin_customer" */
export type DotCheckinCustomer_Aggregate_Fields = {
  __typename?: 'dotCheckinCustomer_aggregate_fields';
  avg?: Maybe<DotCheckinCustomer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DotCheckinCustomer_Max_Fields>;
  min?: Maybe<DotCheckinCustomer_Min_Fields>;
  stddev?: Maybe<DotCheckinCustomer_Stddev_Fields>;
  stddev_pop?: Maybe<DotCheckinCustomer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DotCheckinCustomer_Stddev_Samp_Fields>;
  sum?: Maybe<DotCheckinCustomer_Sum_Fields>;
  var_pop?: Maybe<DotCheckinCustomer_Var_Pop_Fields>;
  var_samp?: Maybe<DotCheckinCustomer_Var_Samp_Fields>;
  variance?: Maybe<DotCheckinCustomer_Variance_Fields>;
};


/** aggregate fields of "dot.checkin_customer" */
export type DotCheckinCustomer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "dot.checkin_customer" */
export type DotCheckinCustomer_Aggregate_Order_By = {
  avg?: InputMaybe<DotCheckinCustomer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DotCheckinCustomer_Max_Order_By>;
  min?: InputMaybe<DotCheckinCustomer_Min_Order_By>;
  stddev?: InputMaybe<DotCheckinCustomer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<DotCheckinCustomer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<DotCheckinCustomer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<DotCheckinCustomer_Sum_Order_By>;
  var_pop?: InputMaybe<DotCheckinCustomer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<DotCheckinCustomer_Var_Samp_Order_By>;
  variance?: InputMaybe<DotCheckinCustomer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "dot.checkin_customer" */
export type DotCheckinCustomer_Arr_Rel_Insert_Input = {
  data: Array<DotCheckinCustomer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<DotCheckinCustomer_On_Conflict>;
};

/** aggregate avg on columns */
export type DotCheckinCustomer_Avg_Fields = {
  __typename?: 'dotCheckinCustomer_avg_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Avg_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dot.checkin_customer". All fields are combined with a logical 'AND'. */
export type DotCheckinCustomer_Bool_Exp = {
  _and?: InputMaybe<Array<DotCheckinCustomer_Bool_Exp>>;
  _not?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
  _or?: InputMaybe<Array<DotCheckinCustomer_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  addressOcr?: InputMaybe<String_Comparison_Exp>;
  backPageType?: InputMaybe<String_Comparison_Exp>;
  checkinAnonymousLink?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
  checkinAnonymousLinkId?: InputMaybe<Uuid_Comparison_Exp>;
  confidenceApiResponseBackPage?: InputMaybe<Numeric_Comparison_Exp>;
  confidenceApiResponseFrontPage?: InputMaybe<Numeric_Comparison_Exp>;
  confirmedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cuttedBackPagePath?: InputMaybe<String_Comparison_Exp>;
  cuttedFrontPagePath?: InputMaybe<String_Comparison_Exp>;
  dateOfBirth?: InputMaybe<Date_Comparison_Exp>;
  dateOfBirthOcr?: InputMaybe<Date_Comparison_Exp>;
  dateOfExpiry?: InputMaybe<Date_Comparison_Exp>;
  dateOfExpiryOcr?: InputMaybe<Date_Comparison_Exp>;
  dateOfIssue?: InputMaybe<Date_Comparison_Exp>;
  debugApiResponseBackPage?: InputMaybe<Json_Comparison_Exp>;
  debugApiResponseFrontPage?: InputMaybe<Json_Comparison_Exp>;
  debugApiUploadBackPage?: InputMaybe<Json_Comparison_Exp>;
  debugApiUploadFrontPage?: InputMaybe<Json_Comparison_Exp>;
  documentNumber?: InputMaybe<String_Comparison_Exp>;
  documentNumberOcr?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Json_Comparison_Exp>;
  frontPageType?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  givenName?: InputMaybe<String_Comparison_Exp>;
  givenNameOcr?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isConfirmed?: InputMaybe<Boolean_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  isOcrDone?: InputMaybe<Boolean_Comparison_Exp>;
  isScanDone?: InputMaybe<Boolean_Comparison_Exp>;
  nationality?: InputMaybe<String_Comparison_Exp>;
  nationalityOcr?: InputMaybe<String_Comparison_Exp>;
  personalNumber?: InputMaybe<String_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  surname?: InputMaybe<String_Comparison_Exp>;
  surnameOcr?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedBackPagePath?: InputMaybe<String_Comparison_Exp>;
  uploadedFrontPagePath?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dot.checkin_customer" */
export enum DotCheckinCustomer_Constraint {
  /** unique or primary key constraint on columns "id" */
  CheckinCustomerPkey = 'checkin_customer_pkey'
}

/** input type for incrementing numeric columns in table "dot.checkin_customer" */
export type DotCheckinCustomer_Inc_Input = {
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "dot.checkin_customer" */
export type DotCheckinCustomer_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressOcr?: InputMaybe<Scalars['String']>;
  backPageType?: InputMaybe<Scalars['String']>;
  checkinAnonymousLink?: InputMaybe<DotCheckinAnonymousLink_Obj_Rel_Insert_Input>;
  checkinAnonymousLinkId?: InputMaybe<Scalars['uuid']>;
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: InputMaybe<Scalars['String']>;
  cuttedFrontPagePath?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  dateOfBirthOcr?: InputMaybe<Scalars['date']>;
  dateOfExpiry?: InputMaybe<Scalars['date']>;
  dateOfExpiryOcr?: InputMaybe<Scalars['date']>;
  dateOfIssue?: InputMaybe<Scalars['date']>;
  debugApiResponseBackPage?: InputMaybe<Scalars['json']>;
  debugApiResponseFrontPage?: InputMaybe<Scalars['json']>;
  debugApiUploadBackPage?: InputMaybe<Scalars['json']>;
  debugApiUploadFrontPage?: InputMaybe<Scalars['json']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentNumberOcr?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['json']>;
  frontPageType?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  givenNameOcr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isOcrDone?: InputMaybe<Scalars['Boolean']>;
  isScanDone?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<Scalars['String']>;
  nationalityOcr?: InputMaybe<Scalars['String']>;
  personalNumber?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  surnameOcr?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: InputMaybe<Scalars['String']>;
  uploadedFrontPagePath?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DotCheckinCustomer_Max_Fields = {
  __typename?: 'dotCheckinCustomer_max_fields';
  address?: Maybe<Scalars['String']>;
  addressOcr?: Maybe<Scalars['String']>;
  backPageType?: Maybe<Scalars['String']>;
  checkinAnonymousLinkId?: Maybe<Scalars['uuid']>;
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: Maybe<Scalars['String']>;
  cuttedFrontPagePath?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  dateOfBirthOcr?: Maybe<Scalars['date']>;
  dateOfExpiry?: Maybe<Scalars['date']>;
  dateOfExpiryOcr?: Maybe<Scalars['date']>;
  dateOfIssue?: Maybe<Scalars['date']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentNumberOcr?: Maybe<Scalars['String']>;
  frontPageType?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameOcr?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nationality?: Maybe<Scalars['String']>;
  nationalityOcr?: Maybe<Scalars['String']>;
  personalNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  surnameOcr?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: Maybe<Scalars['String']>;
  uploadedFrontPagePath?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  addressOcr?: InputMaybe<Order_By>;
  backPageType?: InputMaybe<Order_By>;
  checkinAnonymousLinkId?: InputMaybe<Order_By>;
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttedBackPagePath?: InputMaybe<Order_By>;
  cuttedFrontPagePath?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  dateOfBirthOcr?: InputMaybe<Order_By>;
  dateOfExpiry?: InputMaybe<Order_By>;
  dateOfExpiryOcr?: InputMaybe<Order_By>;
  dateOfIssue?: InputMaybe<Order_By>;
  documentNumber?: InputMaybe<Order_By>;
  documentNumberOcr?: InputMaybe<Order_By>;
  frontPageType?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  givenNameOcr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  nationalityOcr?: InputMaybe<Order_By>;
  personalNumber?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  surname?: InputMaybe<Order_By>;
  surnameOcr?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedBackPagePath?: InputMaybe<Order_By>;
  uploadedFrontPagePath?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type DotCheckinCustomer_Min_Fields = {
  __typename?: 'dotCheckinCustomer_min_fields';
  address?: Maybe<Scalars['String']>;
  addressOcr?: Maybe<Scalars['String']>;
  backPageType?: Maybe<Scalars['String']>;
  checkinAnonymousLinkId?: Maybe<Scalars['uuid']>;
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: Maybe<Scalars['String']>;
  cuttedFrontPagePath?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  dateOfBirthOcr?: Maybe<Scalars['date']>;
  dateOfExpiry?: Maybe<Scalars['date']>;
  dateOfExpiryOcr?: Maybe<Scalars['date']>;
  dateOfIssue?: Maybe<Scalars['date']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentNumberOcr?: Maybe<Scalars['String']>;
  frontPageType?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameOcr?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nationality?: Maybe<Scalars['String']>;
  nationalityOcr?: Maybe<Scalars['String']>;
  personalNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  surnameOcr?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: Maybe<Scalars['String']>;
  uploadedFrontPagePath?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  addressOcr?: InputMaybe<Order_By>;
  backPageType?: InputMaybe<Order_By>;
  checkinAnonymousLinkId?: InputMaybe<Order_By>;
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttedBackPagePath?: InputMaybe<Order_By>;
  cuttedFrontPagePath?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  dateOfBirthOcr?: InputMaybe<Order_By>;
  dateOfExpiry?: InputMaybe<Order_By>;
  dateOfExpiryOcr?: InputMaybe<Order_By>;
  dateOfIssue?: InputMaybe<Order_By>;
  documentNumber?: InputMaybe<Order_By>;
  documentNumberOcr?: InputMaybe<Order_By>;
  frontPageType?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  givenNameOcr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  nationalityOcr?: InputMaybe<Order_By>;
  personalNumber?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  surname?: InputMaybe<Order_By>;
  surnameOcr?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedBackPagePath?: InputMaybe<Order_By>;
  uploadedFrontPagePath?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dot.checkin_customer" */
export type DotCheckinCustomer_Mutation_Response = {
  __typename?: 'dotCheckinCustomer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DotCheckinCustomer>;
};

/** on_conflict condition type for table "dot.checkin_customer" */
export type DotCheckinCustomer_On_Conflict = {
  constraint: DotCheckinCustomer_Constraint;
  update_columns?: Array<DotCheckinCustomer_Update_Column>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};

/** Ordering options when selecting data from "dot.checkin_customer". */
export type DotCheckinCustomer_Order_By = {
  address?: InputMaybe<Order_By>;
  addressOcr?: InputMaybe<Order_By>;
  backPageType?: InputMaybe<Order_By>;
  checkinAnonymousLink?: InputMaybe<DotCheckinAnonymousLink_Order_By>;
  checkinAnonymousLinkId?: InputMaybe<Order_By>;
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttedBackPagePath?: InputMaybe<Order_By>;
  cuttedFrontPagePath?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  dateOfBirthOcr?: InputMaybe<Order_By>;
  dateOfExpiry?: InputMaybe<Order_By>;
  dateOfExpiryOcr?: InputMaybe<Order_By>;
  dateOfIssue?: InputMaybe<Order_By>;
  debugApiResponseBackPage?: InputMaybe<Order_By>;
  debugApiResponseFrontPage?: InputMaybe<Order_By>;
  debugApiUploadBackPage?: InputMaybe<Order_By>;
  debugApiUploadFrontPage?: InputMaybe<Order_By>;
  documentNumber?: InputMaybe<Order_By>;
  documentNumberOcr?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Order_By>;
  frontPageType?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  givenNameOcr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isConfirmed?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  isOcrDone?: InputMaybe<Order_By>;
  isScanDone?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  nationalityOcr?: InputMaybe<Order_By>;
  personalNumber?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  surname?: InputMaybe<Order_By>;
  surnameOcr?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedBackPagePath?: InputMaybe<Order_By>;
  uploadedFrontPagePath?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dot.checkin_customer */
export type DotCheckinCustomer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "dot.checkin_customer" */
export enum DotCheckinCustomer_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressOcr = 'addressOcr',
  /** column name */
  BackPageType = 'backPageType',
  /** column name */
  CheckinAnonymousLinkId = 'checkinAnonymousLinkId',
  /** column name */
  ConfidenceApiResponseBackPage = 'confidenceApiResponseBackPage',
  /** column name */
  ConfidenceApiResponseFrontPage = 'confidenceApiResponseFrontPage',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CuttedBackPagePath = 'cuttedBackPagePath',
  /** column name */
  CuttedFrontPagePath = 'cuttedFrontPagePath',
  /** column name */
  DateOfBirth = 'dateOfBirth',
  /** column name */
  DateOfBirthOcr = 'dateOfBirthOcr',
  /** column name */
  DateOfExpiry = 'dateOfExpiry',
  /** column name */
  DateOfExpiryOcr = 'dateOfExpiryOcr',
  /** column name */
  DateOfIssue = 'dateOfIssue',
  /** column name */
  DebugApiResponseBackPage = 'debugApiResponseBackPage',
  /** column name */
  DebugApiResponseFrontPage = 'debugApiResponseFrontPage',
  /** column name */
  DebugApiUploadBackPage = 'debugApiUploadBackPage',
  /** column name */
  DebugApiUploadFrontPage = 'debugApiUploadFrontPage',
  /** column name */
  DocumentNumber = 'documentNumber',
  /** column name */
  DocumentNumberOcr = 'documentNumberOcr',
  /** column name */
  DocumentType = 'documentType',
  /** column name */
  FrontPageType = 'frontPageType',
  /** column name */
  Gender = 'gender',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  GivenNameOcr = 'givenNameOcr',
  /** column name */
  Id = 'id',
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsScanDone = 'isScanDone',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  NationalityOcr = 'nationalityOcr',
  /** column name */
  PersonalNumber = 'personalNumber',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Surname = 'surname',
  /** column name */
  SurnameOcr = 'surnameOcr',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedBackPagePath = 'uploadedBackPagePath',
  /** column name */
  UploadedFrontPagePath = 'uploadedFrontPagePath'
}

/** select "dotCheckinCustomer_aggregate_bool_exp_bool_and_arguments_columns" columns of table "dot.checkin_customer" */
export enum DotCheckinCustomer_Select_Column_DotCheckinCustomer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsScanDone = 'isScanDone'
}

/** select "dotCheckinCustomer_aggregate_bool_exp_bool_or_arguments_columns" columns of table "dot.checkin_customer" */
export enum DotCheckinCustomer_Select_Column_DotCheckinCustomer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsScanDone = 'isScanDone'
}

/** input type for updating data in table "dot.checkin_customer" */
export type DotCheckinCustomer_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressOcr?: InputMaybe<Scalars['String']>;
  backPageType?: InputMaybe<Scalars['String']>;
  checkinAnonymousLinkId?: InputMaybe<Scalars['uuid']>;
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: InputMaybe<Scalars['String']>;
  cuttedFrontPagePath?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  dateOfBirthOcr?: InputMaybe<Scalars['date']>;
  dateOfExpiry?: InputMaybe<Scalars['date']>;
  dateOfExpiryOcr?: InputMaybe<Scalars['date']>;
  dateOfIssue?: InputMaybe<Scalars['date']>;
  debugApiResponseBackPage?: InputMaybe<Scalars['json']>;
  debugApiResponseFrontPage?: InputMaybe<Scalars['json']>;
  debugApiUploadBackPage?: InputMaybe<Scalars['json']>;
  debugApiUploadFrontPage?: InputMaybe<Scalars['json']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentNumberOcr?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['json']>;
  frontPageType?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  givenNameOcr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isOcrDone?: InputMaybe<Scalars['Boolean']>;
  isScanDone?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<Scalars['String']>;
  nationalityOcr?: InputMaybe<Scalars['String']>;
  personalNumber?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  surnameOcr?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: InputMaybe<Scalars['String']>;
  uploadedFrontPagePath?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DotCheckinCustomer_Stddev_Fields = {
  __typename?: 'dotCheckinCustomer_stddev_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Stddev_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type DotCheckinCustomer_Stddev_Pop_Fields = {
  __typename?: 'dotCheckinCustomer_stddev_pop_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Stddev_Pop_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type DotCheckinCustomer_Stddev_Samp_Fields = {
  __typename?: 'dotCheckinCustomer_stddev_samp_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Stddev_Samp_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dotCheckinCustomer" */
export type DotCheckinCustomer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DotCheckinCustomer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DotCheckinCustomer_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  addressOcr?: InputMaybe<Scalars['String']>;
  backPageType?: InputMaybe<Scalars['String']>;
  checkinAnonymousLinkId?: InputMaybe<Scalars['uuid']>;
  confidenceApiResponseBackPage?: InputMaybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: InputMaybe<Scalars['numeric']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cuttedBackPagePath?: InputMaybe<Scalars['String']>;
  cuttedFrontPagePath?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  dateOfBirthOcr?: InputMaybe<Scalars['date']>;
  dateOfExpiry?: InputMaybe<Scalars['date']>;
  dateOfExpiryOcr?: InputMaybe<Scalars['date']>;
  dateOfIssue?: InputMaybe<Scalars['date']>;
  debugApiResponseBackPage?: InputMaybe<Scalars['json']>;
  debugApiResponseFrontPage?: InputMaybe<Scalars['json']>;
  debugApiUploadBackPage?: InputMaybe<Scalars['json']>;
  debugApiUploadFrontPage?: InputMaybe<Scalars['json']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentNumberOcr?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['json']>;
  frontPageType?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  givenNameOcr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isOcrDone?: InputMaybe<Scalars['Boolean']>;
  isScanDone?: InputMaybe<Scalars['Boolean']>;
  nationality?: InputMaybe<Scalars['String']>;
  nationalityOcr?: InputMaybe<Scalars['String']>;
  personalNumber?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  surnameOcr?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedBackPagePath?: InputMaybe<Scalars['String']>;
  uploadedFrontPagePath?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DotCheckinCustomer_Sum_Fields = {
  __typename?: 'dotCheckinCustomer_sum_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['numeric']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Sum_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** update columns of table "dot.checkin_customer" */
export enum DotCheckinCustomer_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AddressOcr = 'addressOcr',
  /** column name */
  BackPageType = 'backPageType',
  /** column name */
  CheckinAnonymousLinkId = 'checkinAnonymousLinkId',
  /** column name */
  ConfidenceApiResponseBackPage = 'confidenceApiResponseBackPage',
  /** column name */
  ConfidenceApiResponseFrontPage = 'confidenceApiResponseFrontPage',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CuttedBackPagePath = 'cuttedBackPagePath',
  /** column name */
  CuttedFrontPagePath = 'cuttedFrontPagePath',
  /** column name */
  DateOfBirth = 'dateOfBirth',
  /** column name */
  DateOfBirthOcr = 'dateOfBirthOcr',
  /** column name */
  DateOfExpiry = 'dateOfExpiry',
  /** column name */
  DateOfExpiryOcr = 'dateOfExpiryOcr',
  /** column name */
  DateOfIssue = 'dateOfIssue',
  /** column name */
  DebugApiResponseBackPage = 'debugApiResponseBackPage',
  /** column name */
  DebugApiResponseFrontPage = 'debugApiResponseFrontPage',
  /** column name */
  DebugApiUploadBackPage = 'debugApiUploadBackPage',
  /** column name */
  DebugApiUploadFrontPage = 'debugApiUploadFrontPage',
  /** column name */
  DocumentNumber = 'documentNumber',
  /** column name */
  DocumentNumberOcr = 'documentNumberOcr',
  /** column name */
  DocumentType = 'documentType',
  /** column name */
  FrontPageType = 'frontPageType',
  /** column name */
  Gender = 'gender',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  GivenNameOcr = 'givenNameOcr',
  /** column name */
  Id = 'id',
  /** column name */
  IsConfirmed = 'isConfirmed',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsOcrDone = 'isOcrDone',
  /** column name */
  IsScanDone = 'isScanDone',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  NationalityOcr = 'nationalityOcr',
  /** column name */
  PersonalNumber = 'personalNumber',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Surname = 'surname',
  /** column name */
  SurnameOcr = 'surnameOcr',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedBackPagePath = 'uploadedBackPagePath',
  /** column name */
  UploadedFrontPagePath = 'uploadedFrontPagePath'
}

export type DotCheckinCustomer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DotCheckinCustomer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DotCheckinCustomer_Set_Input>;
  /** filter the rows which have to be updated */
  where: DotCheckinCustomer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DotCheckinCustomer_Var_Pop_Fields = {
  __typename?: 'dotCheckinCustomer_var_pop_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Var_Pop_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type DotCheckinCustomer_Var_Samp_Fields = {
  __typename?: 'dotCheckinCustomer_var_samp_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Var_Samp_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type DotCheckinCustomer_Variance_Fields = {
  __typename?: 'dotCheckinCustomer_variance_fields';
  confidenceApiResponseBackPage?: Maybe<Scalars['Float']>;
  confidenceApiResponseFrontPage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "dot.checkin_customer" */
export type DotCheckinCustomer_Variance_Order_By = {
  confidenceApiResponseBackPage?: InputMaybe<Order_By>;
  confidenceApiResponseFrontPage?: InputMaybe<Order_By>;
};

/** aggregated selection of "dot.checkin" */
export type DotCheckin_Aggregate = {
  __typename?: 'dotCheckin_aggregate';
  aggregate?: Maybe<DotCheckin_Aggregate_Fields>;
  nodes: Array<DotCheckin>;
};

/** aggregate fields of "dot.checkin" */
export type DotCheckin_Aggregate_Fields = {
  __typename?: 'dotCheckin_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DotCheckin_Max_Fields>;
  min?: Maybe<DotCheckin_Min_Fields>;
};


/** aggregate fields of "dot.checkin" */
export type DotCheckin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DotCheckin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "dot.checkin". All fields are combined with a logical 'AND'. */
export type DotCheckin_Bool_Exp = {
  _and?: InputMaybe<Array<DotCheckin_Bool_Exp>>;
  _not?: InputMaybe<DotCheckin_Bool_Exp>;
  _or?: InputMaybe<Array<DotCheckin_Bool_Exp>>;
  checkinAnonymousLinks?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
  checkinAnonymousLinks_aggregate?: InputMaybe<DotCheckinAnonymousLink_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  hotelEmail?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dot.checkin" */
export enum DotCheckin_Constraint {
  /** unique or primary key constraint on columns "id" */
  CheckinPkey = 'checkin_pkey'
}

/** input type for inserting data into table "dot.checkin" */
export type DotCheckin_Insert_Input = {
  checkinAnonymousLinks?: InputMaybe<DotCheckinAnonymousLink_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hotelEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DotCheckin_Max_Fields = {
  __typename?: 'dotCheckin_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hotelEmail?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type DotCheckin_Min_Fields = {
  __typename?: 'dotCheckin_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hotelEmail?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "dot.checkin" */
export type DotCheckin_Mutation_Response = {
  __typename?: 'dotCheckin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DotCheckin>;
};

/** input type for inserting object relation for remote table "dot.checkin" */
export type DotCheckin_Obj_Rel_Insert_Input = {
  data: DotCheckin_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DotCheckin_On_Conflict>;
};

/** on_conflict condition type for table "dot.checkin" */
export type DotCheckin_On_Conflict = {
  constraint: DotCheckin_Constraint;
  update_columns?: Array<DotCheckin_Update_Column>;
  where?: InputMaybe<DotCheckin_Bool_Exp>;
};

/** Ordering options when selecting data from "dot.checkin". */
export type DotCheckin_Order_By = {
  checkinAnonymousLinks_aggregate?: InputMaybe<DotCheckinAnonymousLink_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  hotelEmail?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dot.checkin */
export type DotCheckin_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "dot.checkin" */
export enum DotCheckin_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HotelEmail = 'hotelEmail',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "dot.checkin" */
export type DotCheckin_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hotelEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "dotCheckin" */
export type DotCheckin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DotCheckin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DotCheckin_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hotelEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "dot.checkin" */
export enum DotCheckin_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HotelEmail = 'hotelEmail',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DotCheckin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DotCheckin_Set_Input>;
  /** filter the rows which have to be updated */
  where: DotCheckin_Bool_Exp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "checkin.checkin" */
  deleteCheckin?: Maybe<Checkin>;
  /** delete single row from the table: "checkin.checkin_customer" */
  deleteCheckinCustomer?: Maybe<CheckinCustomer>;
  /** delete data from the table: "checkin.checkin_customer" */
  deleteCheckinCustomers?: Maybe<CheckinCustomer_Mutation_Response>;
  /** delete data from the table: "checkin.checkin" */
  deleteCheckins?: Maybe<Checkin_Mutation_Response>;
  /** delete single row from the table: "dot.checkin" */
  deleteDotCheckin?: Maybe<DotCheckin>;
  /** delete single row from the table: "dot.checkin_anonymous_link" */
  deleteDotCheckinAnonymousLink?: Maybe<DotCheckinAnonymousLink>;
  /** delete data from the table: "dot.checkin_anonymous_link" */
  deleteDotCheckinAnonymousLinks?: Maybe<DotCheckinAnonymousLink_Mutation_Response>;
  /** delete single row from the table: "dot.checkin_customer" */
  deleteDotCheckinCustomer?: Maybe<DotCheckinCustomer>;
  /** delete data from the table: "dot.checkin_customer" */
  deleteDotCheckinCustomers?: Maybe<DotCheckinCustomer_Mutation_Response>;
  /** delete data from the table: "dot.checkin" */
  deleteDotCheckins?: Maybe<DotCheckin_Mutation_Response>;
  /** delete single row from the table: "checkin.notifications" */
  deleteNotification?: Maybe<Notifications>;
  /** delete data from the table: "checkin.notifications" */
  deleteNotifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "checkin.organization" */
  deleteOrganization?: Maybe<Organization>;
  /** delete data from the table: "checkin.organization" */
  deleteOrganizations?: Maybe<Organization_Mutation_Response>;
  /** delete single row from the table: "checkin.shared_link" */
  deleteSharedLink?: Maybe<SharedLink>;
  /** delete data from the table: "checkin.shared_link" */
  deleteSharedLinks?: Maybe<SharedLink_Mutation_Response>;
  /** insert a single row into the table: "checkin.checkin" */
  insertCheckin?: Maybe<Checkin>;
  /** insert a single row into the table: "checkin.checkin_customer" */
  insertCheckinCustomer?: Maybe<CheckinCustomer>;
  /** insert data into the table: "checkin.checkin_customer" */
  insertCheckinCustomers?: Maybe<CheckinCustomer_Mutation_Response>;
  /** insert data into the table: "checkin.checkin" */
  insertCheckins?: Maybe<Checkin_Mutation_Response>;
  /** insert a single row into the table: "dot.checkin" */
  insertDotCheckin?: Maybe<DotCheckin>;
  /** insert a single row into the table: "dot.checkin_anonymous_link" */
  insertDotCheckinAnonymousLink?: Maybe<DotCheckinAnonymousLink>;
  /** insert data into the table: "dot.checkin_anonymous_link" */
  insertDotCheckinAnonymousLinks?: Maybe<DotCheckinAnonymousLink_Mutation_Response>;
  /** insert a single row into the table: "dot.checkin_customer" */
  insertDotCheckinCustomer?: Maybe<DotCheckinCustomer>;
  /** insert data into the table: "dot.checkin_customer" */
  insertDotCheckinCustomers?: Maybe<DotCheckinCustomer_Mutation_Response>;
  /** insert data into the table: "dot.checkin" */
  insertDotCheckins?: Maybe<DotCheckin_Mutation_Response>;
  /** insert a single row into the table: "checkin.notifications" */
  insertNotification?: Maybe<Notifications>;
  /** insert data into the table: "checkin.notifications" */
  insertNotifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "checkin.organization" */
  insertOrganization?: Maybe<Organization>;
  /** insert data into the table: "checkin.organization" */
  insertOrganizations?: Maybe<Organization_Mutation_Response>;
  /** insert a single row into the table: "checkin.shared_link" */
  insertSharedLink?: Maybe<SharedLink>;
  /** insert data into the table: "checkin.shared_link" */
  insertSharedLinks?: Maybe<SharedLink_Mutation_Response>;
  /** update single row of the table: "checkin.checkin" */
  updateCheckin?: Maybe<Checkin>;
  /** update single row of the table: "checkin.checkin_customer" */
  updateCheckinCustomer?: Maybe<CheckinCustomer>;
  /** update data of the table: "checkin.checkin_customer" */
  updateCheckinCustomers?: Maybe<CheckinCustomer_Mutation_Response>;
  /** update data of the table: "checkin.checkin" */
  updateCheckins?: Maybe<Checkin_Mutation_Response>;
  /** update single row of the table: "dot.checkin" */
  updateDotCheckin?: Maybe<DotCheckin>;
  /** update single row of the table: "dot.checkin_anonymous_link" */
  updateDotCheckinAnonymousLink?: Maybe<DotCheckinAnonymousLink>;
  /** update data of the table: "dot.checkin_anonymous_link" */
  updateDotCheckinAnonymousLinks?: Maybe<DotCheckinAnonymousLink_Mutation_Response>;
  /** update single row of the table: "dot.checkin_customer" */
  updateDotCheckinCustomer?: Maybe<DotCheckinCustomer>;
  /** update data of the table: "dot.checkin_customer" */
  updateDotCheckinCustomers?: Maybe<DotCheckinCustomer_Mutation_Response>;
  /** update data of the table: "dot.checkin" */
  updateDotCheckins?: Maybe<DotCheckin_Mutation_Response>;
  /** update single row of the table: "checkin.notifications" */
  updateNotification?: Maybe<Notifications>;
  /** update data of the table: "checkin.notifications" */
  updateNotifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "checkin.organization" */
  updateOrganization?: Maybe<Organization>;
  /** update data of the table: "checkin.organization" */
  updateOrganizations?: Maybe<Organization_Mutation_Response>;
  /** update single row of the table: "checkin.shared_link" */
  updateSharedLink?: Maybe<SharedLink>;
  /** update data of the table: "checkin.shared_link" */
  updateSharedLinks?: Maybe<SharedLink_Mutation_Response>;
  /** update multiples rows of table: "checkin.checkin_customer" */
  update_checkinCustomer_many?: Maybe<Array<Maybe<CheckinCustomer_Mutation_Response>>>;
  /** update multiples rows of table: "checkin.checkin" */
  update_checkin_many?: Maybe<Array<Maybe<Checkin_Mutation_Response>>>;
  /** update multiples rows of table: "dot.checkin_anonymous_link" */
  update_dotCheckinAnonymousLink_many?: Maybe<Array<Maybe<DotCheckinAnonymousLink_Mutation_Response>>>;
  /** update multiples rows of table: "dot.checkin_customer" */
  update_dotCheckinCustomer_many?: Maybe<Array<Maybe<DotCheckinCustomer_Mutation_Response>>>;
  /** update multiples rows of table: "dot.checkin" */
  update_dotCheckin_many?: Maybe<Array<Maybe<DotCheckin_Mutation_Response>>>;
  /** update multiples rows of table: "checkin.notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update multiples rows of table: "checkin.organization" */
  update_organization_many?: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update multiples rows of table: "checkin.shared_link" */
  update_sharedLink_many?: Maybe<Array<Maybe<SharedLink_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDeleteCheckinArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCheckinCustomerArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCheckinCustomersArgs = {
  where: CheckinCustomer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCheckinsArgs = {
  where: Checkin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDotCheckinArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDotCheckinAnonymousLinkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDotCheckinAnonymousLinksArgs = {
  where: DotCheckinAnonymousLink_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDotCheckinCustomerArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDotCheckinCustomersArgs = {
  where: DotCheckinCustomer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDotCheckinsArgs = {
  where: DotCheckin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteOrganizationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOrganizationsArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSharedLinkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteSharedLinksArgs = {
  where: SharedLink_Bool_Exp;
};


/** mutation root */
export type Mutation_RootInsertCheckinArgs = {
  object: Checkin_Insert_Input;
  on_conflict?: InputMaybe<Checkin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCheckinCustomerArgs = {
  object: CheckinCustomer_Insert_Input;
  on_conflict?: InputMaybe<CheckinCustomer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCheckinCustomersArgs = {
  objects: Array<CheckinCustomer_Insert_Input>;
  on_conflict?: InputMaybe<CheckinCustomer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCheckinsArgs = {
  objects: Array<Checkin_Insert_Input>;
  on_conflict?: InputMaybe<Checkin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDotCheckinArgs = {
  object: DotCheckin_Insert_Input;
  on_conflict?: InputMaybe<DotCheckin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDotCheckinAnonymousLinkArgs = {
  object: DotCheckinAnonymousLink_Insert_Input;
  on_conflict?: InputMaybe<DotCheckinAnonymousLink_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDotCheckinAnonymousLinksArgs = {
  objects: Array<DotCheckinAnonymousLink_Insert_Input>;
  on_conflict?: InputMaybe<DotCheckinAnonymousLink_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDotCheckinCustomerArgs = {
  object: DotCheckinCustomer_Insert_Input;
  on_conflict?: InputMaybe<DotCheckinCustomer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDotCheckinCustomersArgs = {
  objects: Array<DotCheckinCustomer_Insert_Input>;
  on_conflict?: InputMaybe<DotCheckinCustomer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDotCheckinsArgs = {
  objects: Array<DotCheckin_Insert_Input>;
  on_conflict?: InputMaybe<DotCheckin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertNotificationArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertNotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertOrganizationArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertOrganizationsArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSharedLinkArgs = {
  object: SharedLink_Insert_Input;
  on_conflict?: InputMaybe<SharedLink_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSharedLinksArgs = {
  objects: Array<SharedLink_Insert_Input>;
  on_conflict?: InputMaybe<SharedLink_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdateCheckinArgs = {
  _set?: InputMaybe<Checkin_Set_Input>;
  pk_columns: Checkin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCheckinCustomerArgs = {
  _inc?: InputMaybe<CheckinCustomer_Inc_Input>;
  _set?: InputMaybe<CheckinCustomer_Set_Input>;
  pk_columns: CheckinCustomer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCheckinCustomersArgs = {
  _inc?: InputMaybe<CheckinCustomer_Inc_Input>;
  _set?: InputMaybe<CheckinCustomer_Set_Input>;
  where: CheckinCustomer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCheckinsArgs = {
  _set?: InputMaybe<Checkin_Set_Input>;
  where: Checkin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDotCheckinArgs = {
  _set?: InputMaybe<DotCheckin_Set_Input>;
  pk_columns: DotCheckin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDotCheckinAnonymousLinkArgs = {
  _set?: InputMaybe<DotCheckinAnonymousLink_Set_Input>;
  pk_columns: DotCheckinAnonymousLink_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDotCheckinAnonymousLinksArgs = {
  _set?: InputMaybe<DotCheckinAnonymousLink_Set_Input>;
  where: DotCheckinAnonymousLink_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDotCheckinCustomerArgs = {
  _inc?: InputMaybe<DotCheckinCustomer_Inc_Input>;
  _set?: InputMaybe<DotCheckinCustomer_Set_Input>;
  pk_columns: DotCheckinCustomer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDotCheckinCustomersArgs = {
  _inc?: InputMaybe<DotCheckinCustomer_Inc_Input>;
  _set?: InputMaybe<DotCheckinCustomer_Set_Input>;
  where: DotCheckinCustomer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDotCheckinsArgs = {
  _set?: InputMaybe<DotCheckin_Set_Input>;
  where: DotCheckin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationArgs = {
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateNotificationsArgs = {
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationArgs = {
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationsArgs = {
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSharedLinkArgs = {
  _set?: InputMaybe<SharedLink_Set_Input>;
  pk_columns: SharedLink_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateSharedLinksArgs = {
  _set?: InputMaybe<SharedLink_Set_Input>;
  where: SharedLink_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CheckinCustomer_ManyArgs = {
  updates: Array<CheckinCustomer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Checkin_ManyArgs = {
  updates: Array<Checkin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DotCheckinAnonymousLink_ManyArgs = {
  updates: Array<DotCheckinAnonymousLink_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DotCheckinCustomer_ManyArgs = {
  updates: Array<DotCheckinCustomer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DotCheckin_ManyArgs = {
  updates: Array<DotCheckin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SharedLink_ManyArgs = {
  updates: Array<SharedLink_Updates>;
};

/** columns and relationships of "checkin.notifications" */
export type Notifications = {
  __typename?: 'notifications';
  /** An object relationship */
  checkinCustomer: CheckinCustomer;
  checkinCustomerId: Scalars['uuid'];
  checkinNumber: Scalars['String'];
  dateOfArrival: Scalars['date'];
  id: Scalars['uuid'];
  organizationEmail: Scalars['String'];
  organizationName: Scalars['String'];
  recipientEmail: Scalars['String'];
  templateId: Scalars['String'];
};

/** aggregated selection of "checkin.notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

export type Notifications_Aggregate_Bool_Exp = {
  count?: InputMaybe<Notifications_Aggregate_Bool_Exp_Count>;
};

export type Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "checkin.notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
};


/** aggregate fields of "checkin.notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "checkin.notifications" */
export type Notifications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notifications_Max_Order_By>;
  min?: InputMaybe<Notifications_Min_Order_By>;
};

/** input type for inserting array relation for remote table "checkin.notifications" */
export type Notifications_Arr_Rel_Insert_Input = {
  data: Array<Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};

/** Boolean expression to filter rows from the table "checkin.notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  checkinCustomer?: InputMaybe<CheckinCustomer_Bool_Exp>;
  checkinCustomerId?: InputMaybe<Uuid_Comparison_Exp>;
  checkinNumber?: InputMaybe<String_Comparison_Exp>;
  dateOfArrival?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organizationEmail?: InputMaybe<String_Comparison_Exp>;
  organizationName?: InputMaybe<String_Comparison_Exp>;
  recipientEmail?: InputMaybe<String_Comparison_Exp>;
  templateId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkin.notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey'
}

/** input type for inserting data into table "checkin.notifications" */
export type Notifications_Insert_Input = {
  checkinCustomer?: InputMaybe<CheckinCustomer_Obj_Rel_Insert_Input>;
  checkinCustomerId?: InputMaybe<Scalars['uuid']>;
  checkinNumber?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  organizationEmail?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  recipientEmail?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  checkinCustomerId?: Maybe<Scalars['uuid']>;
  checkinNumber?: Maybe<Scalars['String']>;
  dateOfArrival?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  organizationEmail?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "checkin.notifications" */
export type Notifications_Max_Order_By = {
  checkinCustomerId?: InputMaybe<Order_By>;
  checkinNumber?: InputMaybe<Order_By>;
  dateOfArrival?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationEmail?: InputMaybe<Order_By>;
  organizationName?: InputMaybe<Order_By>;
  recipientEmail?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  checkinCustomerId?: Maybe<Scalars['uuid']>;
  checkinNumber?: Maybe<Scalars['String']>;
  dateOfArrival?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  organizationEmail?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "checkin.notifications" */
export type Notifications_Min_Order_By = {
  checkinCustomerId?: InputMaybe<Order_By>;
  checkinNumber?: InputMaybe<Order_By>;
  dateOfArrival?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationEmail?: InputMaybe<Order_By>;
  organizationName?: InputMaybe<Order_By>;
  recipientEmail?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "checkin.notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "checkin.notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "checkin.notifications". */
export type Notifications_Order_By = {
  checkinCustomer?: InputMaybe<CheckinCustomer_Order_By>;
  checkinCustomerId?: InputMaybe<Order_By>;
  checkinNumber?: InputMaybe<Order_By>;
  dateOfArrival?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationEmail?: InputMaybe<Order_By>;
  organizationName?: InputMaybe<Order_By>;
  recipientEmail?: InputMaybe<Order_By>;
  templateId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: checkin.notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "checkin.notifications" */
export enum Notifications_Select_Column {
  /** column name */
  CheckinCustomerId = 'checkinCustomerId',
  /** column name */
  CheckinNumber = 'checkinNumber',
  /** column name */
  DateOfArrival = 'dateOfArrival',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationEmail = 'organizationEmail',
  /** column name */
  OrganizationName = 'organizationName',
  /** column name */
  RecipientEmail = 'recipientEmail',
  /** column name */
  TemplateId = 'templateId'
}

/** input type for updating data in table "checkin.notifications" */
export type Notifications_Set_Input = {
  checkinCustomerId?: InputMaybe<Scalars['uuid']>;
  checkinNumber?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  organizationEmail?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  recipientEmail?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  checkinCustomerId?: InputMaybe<Scalars['uuid']>;
  checkinNumber?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  organizationEmail?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  recipientEmail?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "checkin.notifications" */
export enum Notifications_Update_Column {
  /** column name */
  CheckinCustomerId = 'checkinCustomerId',
  /** column name */
  CheckinNumber = 'checkinNumber',
  /** column name */
  DateOfArrival = 'dateOfArrival',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationEmail = 'organizationEmail',
  /** column name */
  OrganizationName = 'organizationName',
  /** column name */
  RecipientEmail = 'recipientEmail',
  /** column name */
  TemplateId = 'templateId'
}

export type Notifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notifications_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "checkin.organization" */
export type Organization = {
  __typename?: 'organization';
  /** An array relationship */
  checkins: Array<Checkin>;
  /** An aggregate relationship */
  checkins_aggregate: Checkin_Aggregate;
  createdAt: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  logoFilePath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  newsletter?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  sharedLinks: Array<SharedLink>;
  /** An aggregate relationship */
  sharedLinks_aggregate: SharedLink_Aggregate;
  /** JWT subject */
  sub: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "checkin.organization" */
export type OrganizationCheckinsArgs = {
  distinct_on?: InputMaybe<Array<Checkin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkin_Order_By>>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};


/** columns and relationships of "checkin.organization" */
export type OrganizationCheckins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkin_Order_By>>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};


/** columns and relationships of "checkin.organization" */
export type OrganizationSharedLinksArgs = {
  distinct_on?: InputMaybe<Array<SharedLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SharedLink_Order_By>>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};


/** columns and relationships of "checkin.organization" */
export type OrganizationSharedLinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SharedLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SharedLink_Order_By>>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};

/** aggregated selection of "checkin.organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate?: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

/** aggregate fields of "checkin.organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Max_Fields>;
  min?: Maybe<Organization_Min_Fields>;
};


/** aggregate fields of "checkin.organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "checkin.organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  checkins?: InputMaybe<Checkin_Bool_Exp>;
  checkins_aggregate?: InputMaybe<Checkin_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  logoFilePath?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  newsletter?: InputMaybe<Boolean_Comparison_Exp>;
  notifications?: InputMaybe<Boolean_Comparison_Exp>;
  sharedLinks?: InputMaybe<SharedLink_Bool_Exp>;
  sharedLinks_aggregate?: InputMaybe<SharedLink_Aggregate_Bool_Exp>;
  sub?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkin.organization" */
export enum Organization_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationPkey = 'organization_pkey',
  /** unique or primary key constraint on columns "sub" */
  OrganizationSubKey = 'organization_sub_key'
}

/** input type for inserting data into table "checkin.organization" */
export type Organization_Insert_Input = {
  checkins?: InputMaybe<Checkin_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  logoFilePath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  sharedLinks?: InputMaybe<SharedLink_Arr_Rel_Insert_Input>;
  /** JWT subject */
  sub?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logoFilePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** JWT subject */
  sub?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logoFilePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** JWT subject */
  sub?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "checkin.organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "checkin.organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "checkin.organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "checkin.organization". */
export type Organization_Order_By = {
  checkins_aggregate?: InputMaybe<Checkin_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  logoFilePath?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  newsletter?: InputMaybe<Order_By>;
  notifications?: InputMaybe<Order_By>;
  sharedLinks_aggregate?: InputMaybe<SharedLink_Aggregate_Order_By>;
  sub?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: checkin.organization */
export type Organization_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "checkin.organization" */
export enum Organization_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  LogoFilePath = 'logoFilePath',
  /** column name */
  Name = 'name',
  /** column name */
  Newsletter = 'newsletter',
  /** column name */
  Notifications = 'notifications',
  /** column name */
  Sub = 'sub',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "checkin.organization" */
export type Organization_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  logoFilePath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  /** JWT subject */
  sub?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  logoFilePath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  /** JWT subject */
  sub?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "checkin.organization" */
export enum Organization_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  LogoFilePath = 'logoFilePath',
  /** column name */
  Name = 'name',
  /** column name */
  Newsletter = 'newsletter',
  /** column name */
  Notifications = 'notifications',
  /** column name */
  Sub = 'sub',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Organization_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "checkin.checkin" using primary key columns */
  checkin?: Maybe<Checkin>;
  /** fetch data from the table: "checkin.checkin_customer" using primary key columns */
  checkinCustomer?: Maybe<CheckinCustomer>;
  /** An array relationship */
  checkinCustomers: Array<CheckinCustomer>;
  /** fetch aggregated fields from the table: "checkin.checkin_customer" */
  checkinCustomersAggregate: CheckinCustomer_Aggregate;
  /** An array relationship */
  checkins: Array<Checkin>;
  /** fetch aggregated fields from the table: "checkin.checkin" */
  checkinsAggregate: Checkin_Aggregate;
  /** fetch data from the table: "dot.checkin" using primary key columns */
  dotCheckin?: Maybe<DotCheckin>;
  /** fetch data from the table: "dot.checkin_anonymous_link" using primary key columns */
  dotCheckinAnonymousLink?: Maybe<DotCheckinAnonymousLink>;
  /** fetch data from the table: "dot.checkin_anonymous_link" */
  dotCheckinAnonymousLinks: Array<DotCheckinAnonymousLink>;
  /** fetch aggregated fields from the table: "dot.checkin_anonymous_link" */
  dotCheckinAnonymousLinksAggregate: DotCheckinAnonymousLink_Aggregate;
  /** fetch data from the table: "dot.checkin_customer" using primary key columns */
  dotCheckinCustomer?: Maybe<DotCheckinCustomer>;
  /** fetch data from the table: "dot.checkin_customer" */
  dotCheckinCustomers: Array<DotCheckinCustomer>;
  /** fetch aggregated fields from the table: "dot.checkin_customer" */
  dotCheckinCustomersAggregate: DotCheckinCustomer_Aggregate;
  /** fetch data from the table: "dot.checkin" */
  dotCheckins: Array<DotCheckin>;
  /** fetch aggregated fields from the table: "dot.checkin" */
  dotCheckinsAggregate: DotCheckin_Aggregate;
  /** fetch data from the table: "checkin.notifications" using primary key columns */
  notification?: Maybe<Notifications>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "checkin.notifications" */
  notificationsAggregate: Notifications_Aggregate;
  /** fetch data from the table: "checkin.organization" using primary key columns */
  organization?: Maybe<Organization>;
  /** fetch data from the table: "checkin.organization" */
  organizations: Array<Organization>;
  /** fetch aggregated fields from the table: "checkin.organization" */
  organizationsAggregate: Organization_Aggregate;
  /** fetch data from the table: "checkin.shared_link" using primary key columns */
  sharedLink?: Maybe<SharedLink>;
  /** An array relationship */
  sharedLinks: Array<SharedLink>;
  /** fetch aggregated fields from the table: "checkin.shared_link" */
  sharedLinksAggregate: SharedLink_Aggregate;
};


export type Query_RootCheckinArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCheckinCustomerArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCheckinCustomersArgs = {
  distinct_on?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CheckinCustomer_Order_By>>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};


export type Query_RootCheckinCustomersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CheckinCustomer_Order_By>>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};


export type Query_RootCheckinsArgs = {
  distinct_on?: InputMaybe<Array<Checkin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkin_Order_By>>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};


export type Query_RootCheckinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkin_Order_By>>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};


export type Query_RootDotCheckinArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDotCheckinAnonymousLinkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDotCheckinAnonymousLinksArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinAnonymousLink_Order_By>>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};


export type Query_RootDotCheckinAnonymousLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinAnonymousLink_Order_By>>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};


export type Query_RootDotCheckinCustomerArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDotCheckinCustomersArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinCustomer_Order_By>>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};


export type Query_RootDotCheckinCustomersAggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinCustomer_Order_By>>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};


export type Query_RootDotCheckinsArgs = {
  distinct_on?: InputMaybe<Array<DotCheckin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckin_Order_By>>;
  where?: InputMaybe<DotCheckin_Bool_Exp>;
};


export type Query_RootDotCheckinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckin_Order_By>>;
  where?: InputMaybe<DotCheckin_Bool_Exp>;
};


export type Query_RootNotificationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotificationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootOrganizationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootSharedLinkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSharedLinksArgs = {
  distinct_on?: InputMaybe<Array<SharedLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SharedLink_Order_By>>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};


export type Query_RootSharedLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<SharedLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SharedLink_Order_By>>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};

/** columns and relationships of "checkin.shared_link" */
export type SharedLink = {
  __typename?: 'sharedLink';
  createdAt: Scalars['timestamptz'];
  hash: Scalars['String'];
  id: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "checkin.shared_link" */
export type SharedLink_Aggregate = {
  __typename?: 'sharedLink_aggregate';
  aggregate?: Maybe<SharedLink_Aggregate_Fields>;
  nodes: Array<SharedLink>;
};

export type SharedLink_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<SharedLink_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<SharedLink_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<SharedLink_Aggregate_Bool_Exp_Count>;
};

export type SharedLink_Aggregate_Bool_Exp_Bool_And = {
  arguments: SharedLink_Select_Column_SharedLink_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SharedLink_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type SharedLink_Aggregate_Bool_Exp_Bool_Or = {
  arguments: SharedLink_Select_Column_SharedLink_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SharedLink_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type SharedLink_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SharedLink_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SharedLink_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "checkin.shared_link" */
export type SharedLink_Aggregate_Fields = {
  __typename?: 'sharedLink_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<SharedLink_Max_Fields>;
  min?: Maybe<SharedLink_Min_Fields>;
};


/** aggregate fields of "checkin.shared_link" */
export type SharedLink_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SharedLink_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "checkin.shared_link" */
export type SharedLink_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SharedLink_Max_Order_By>;
  min?: InputMaybe<SharedLink_Min_Order_By>;
};

/** input type for inserting array relation for remote table "checkin.shared_link" */
export type SharedLink_Arr_Rel_Insert_Input = {
  data: Array<SharedLink_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SharedLink_On_Conflict>;
};

/** Boolean expression to filter rows from the table "checkin.shared_link". All fields are combined with a logical 'AND'. */
export type SharedLink_Bool_Exp = {
  _and?: InputMaybe<Array<SharedLink_Bool_Exp>>;
  _not?: InputMaybe<SharedLink_Bool_Exp>;
  _or?: InputMaybe<Array<SharedLink_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkin.shared_link" */
export enum SharedLink_Constraint {
  /** unique or primary key constraint on columns "hash" */
  SharedLinkHashKey = 'shared_link_hash_key',
  /** unique or primary key constraint on columns "id" */
  SharedLinkIdKey = 'shared_link_id_key',
  /** unique or primary key constraint on columns "id" */
  SharedLinkPkey = 'shared_link_pkey'
}

/** input type for inserting data into table "checkin.shared_link" */
export type SharedLink_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SharedLink_Max_Fields = {
  __typename?: 'sharedLink_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organizationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "checkin.shared_link" */
export type SharedLink_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SharedLink_Min_Fields = {
  __typename?: 'sharedLink_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organizationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "checkin.shared_link" */
export type SharedLink_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "checkin.shared_link" */
export type SharedLink_Mutation_Response = {
  __typename?: 'sharedLink_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SharedLink>;
};

/** on_conflict condition type for table "checkin.shared_link" */
export type SharedLink_On_Conflict = {
  constraint: SharedLink_Constraint;
  update_columns?: Array<SharedLink_Update_Column>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};

/** Ordering options when selecting data from "checkin.shared_link". */
export type SharedLink_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: checkin.shared_link */
export type SharedLink_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "checkin.shared_link" */
export enum SharedLink_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "sharedLink_aggregate_bool_exp_bool_and_arguments_columns" columns of table "checkin.shared_link" */
export enum SharedLink_Select_Column_SharedLink_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** select "sharedLink_aggregate_bool_exp_bool_or_arguments_columns" columns of table "checkin.shared_link" */
export enum SharedLink_Select_Column_SharedLink_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** input type for updating data in table "checkin.shared_link" */
export type SharedLink_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "sharedLink" */
export type SharedLink_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SharedLink_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SharedLink_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "checkin.shared_link" */
export enum SharedLink_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SharedLink_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SharedLink_Set_Input>;
  /** filter the rows which have to be updated */
  where: SharedLink_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "checkin.checkin" using primary key columns */
  checkin?: Maybe<Checkin>;
  /** fetch data from the table: "checkin.checkin_customer" using primary key columns */
  checkinCustomer?: Maybe<CheckinCustomer>;
  /** fetch data from the table in a streaming manner: "checkin.checkin_customer" */
  checkinCustomer_stream: Array<CheckinCustomer>;
  /** An array relationship */
  checkinCustomers: Array<CheckinCustomer>;
  /** fetch aggregated fields from the table: "checkin.checkin_customer" */
  checkinCustomersAggregate: CheckinCustomer_Aggregate;
  /** fetch data from the table in a streaming manner: "checkin.checkin" */
  checkin_stream: Array<Checkin>;
  /** An array relationship */
  checkins: Array<Checkin>;
  /** fetch aggregated fields from the table: "checkin.checkin" */
  checkinsAggregate: Checkin_Aggregate;
  /** fetch data from the table: "dot.checkin" using primary key columns */
  dotCheckin?: Maybe<DotCheckin>;
  /** fetch data from the table: "dot.checkin_anonymous_link" using primary key columns */
  dotCheckinAnonymousLink?: Maybe<DotCheckinAnonymousLink>;
  /** fetch data from the table in a streaming manner: "dot.checkin_anonymous_link" */
  dotCheckinAnonymousLink_stream: Array<DotCheckinAnonymousLink>;
  /** fetch data from the table: "dot.checkin_anonymous_link" */
  dotCheckinAnonymousLinks: Array<DotCheckinAnonymousLink>;
  /** fetch aggregated fields from the table: "dot.checkin_anonymous_link" */
  dotCheckinAnonymousLinksAggregate: DotCheckinAnonymousLink_Aggregate;
  /** fetch data from the table: "dot.checkin_customer" using primary key columns */
  dotCheckinCustomer?: Maybe<DotCheckinCustomer>;
  /** fetch data from the table in a streaming manner: "dot.checkin_customer" */
  dotCheckinCustomer_stream: Array<DotCheckinCustomer>;
  /** fetch data from the table: "dot.checkin_customer" */
  dotCheckinCustomers: Array<DotCheckinCustomer>;
  /** fetch aggregated fields from the table: "dot.checkin_customer" */
  dotCheckinCustomersAggregate: DotCheckinCustomer_Aggregate;
  /** fetch data from the table in a streaming manner: "dot.checkin" */
  dotCheckin_stream: Array<DotCheckin>;
  /** fetch data from the table: "dot.checkin" */
  dotCheckins: Array<DotCheckin>;
  /** fetch aggregated fields from the table: "dot.checkin" */
  dotCheckinsAggregate: DotCheckin_Aggregate;
  /** fetch data from the table: "checkin.notifications" using primary key columns */
  notification?: Maybe<Notifications>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "checkin.notifications" */
  notificationsAggregate: Notifications_Aggregate;
  /** fetch data from the table in a streaming manner: "checkin.notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "checkin.organization" using primary key columns */
  organization?: Maybe<Organization>;
  /** fetch data from the table in a streaming manner: "checkin.organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "checkin.organization" */
  organizations: Array<Organization>;
  /** fetch aggregated fields from the table: "checkin.organization" */
  organizationsAggregate: Organization_Aggregate;
  /** fetch data from the table: "checkin.shared_link" using primary key columns */
  sharedLink?: Maybe<SharedLink>;
  /** fetch data from the table in a streaming manner: "checkin.shared_link" */
  sharedLink_stream: Array<SharedLink>;
  /** An array relationship */
  sharedLinks: Array<SharedLink>;
  /** fetch aggregated fields from the table: "checkin.shared_link" */
  sharedLinksAggregate: SharedLink_Aggregate;
};


export type Subscription_RootCheckinArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCheckinCustomerArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCheckinCustomer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CheckinCustomer_Stream_Cursor_Input>>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};


export type Subscription_RootCheckinCustomersArgs = {
  distinct_on?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CheckinCustomer_Order_By>>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};


export type Subscription_RootCheckinCustomersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CheckinCustomer_Order_By>>;
  where?: InputMaybe<CheckinCustomer_Bool_Exp>;
};


export type Subscription_RootCheckin_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Checkin_Stream_Cursor_Input>>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};


export type Subscription_RootCheckinsArgs = {
  distinct_on?: InputMaybe<Array<Checkin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkin_Order_By>>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};


export type Subscription_RootCheckinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Checkin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Checkin_Order_By>>;
  where?: InputMaybe<Checkin_Bool_Exp>;
};


export type Subscription_RootDotCheckinArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDotCheckinAnonymousLinkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDotCheckinAnonymousLink_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DotCheckinAnonymousLink_Stream_Cursor_Input>>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};


export type Subscription_RootDotCheckinAnonymousLinksArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinAnonymousLink_Order_By>>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};


export type Subscription_RootDotCheckinAnonymousLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinAnonymousLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinAnonymousLink_Order_By>>;
  where?: InputMaybe<DotCheckinAnonymousLink_Bool_Exp>;
};


export type Subscription_RootDotCheckinCustomerArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDotCheckinCustomer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DotCheckinCustomer_Stream_Cursor_Input>>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};


export type Subscription_RootDotCheckinCustomersArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinCustomer_Order_By>>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};


export type Subscription_RootDotCheckinCustomersAggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckinCustomer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckinCustomer_Order_By>>;
  where?: InputMaybe<DotCheckinCustomer_Bool_Exp>;
};


export type Subscription_RootDotCheckin_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DotCheckin_Stream_Cursor_Input>>;
  where?: InputMaybe<DotCheckin_Bool_Exp>;
};


export type Subscription_RootDotCheckinsArgs = {
  distinct_on?: InputMaybe<Array<DotCheckin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckin_Order_By>>;
  where?: InputMaybe<DotCheckin_Bool_Exp>;
};


export type Subscription_RootDotCheckinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DotCheckin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DotCheckin_Order_By>>;
  where?: InputMaybe<DotCheckin_Bool_Exp>;
};


export type Subscription_RootNotificationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotificationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootSharedLinkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSharedLink_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SharedLink_Stream_Cursor_Input>>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};


export type Subscription_RootSharedLinksArgs = {
  distinct_on?: InputMaybe<Array<SharedLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SharedLink_Order_By>>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};


export type Subscription_RootSharedLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<SharedLink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SharedLink_Order_By>>;
  where?: InputMaybe<SharedLink_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timetz']>;
  _gt?: InputMaybe<Scalars['timetz']>;
  _gte?: InputMaybe<Scalars['timetz']>;
  _in?: InputMaybe<Array<Scalars['timetz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timetz']>;
  _lte?: InputMaybe<Scalars['timetz']>;
  _neq?: InputMaybe<Scalars['timetz']>;
  _nin?: InputMaybe<Array<Scalars['timetz']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type GetSharedLinkQueryVariables = Exact<{
  hash: Scalars['String'];
}>;


export type GetSharedLinkQuery = { __typename?: 'query_root', sharedLinks: Array<{ __typename?: 'sharedLink', organization: { __typename?: 'organization', id: any, name: string, email?: string | null } }> };

export type GetSharedLinkFieldsFragment = { __typename?: 'sharedLink', organization: { __typename?: 'organization', id: any, name: string, email?: string | null } };

export type GetLastCustomerSubscriptionVariables = Exact<{
  customerId: Scalars['uuid'];
}>;


export type GetLastCustomerSubscription = { __typename?: 'subscription_root', checkinCustomer?: { __typename?: 'checkinCustomer', id: any, surname?: string | null, givenName?: string | null, dateOfBirth?: any | null, dateOfExpiry?: any | null, dateOfArrival?: any | null, address?: string | null, nationality?: string | null, documentNumber?: string | null, documentType?: string | null, email?: string | null, checkinNumber?: string | null, uploadedFrontPagePath?: string | null, uploadedBackPagePath?: string | null, frontPageType?: string | null, backPageType?: string | null, isConfirmed: boolean, isOcrDone: boolean, isScanDone: boolean } | null };

export type GetLastCustomerFieldsFragment = { __typename?: 'checkinCustomer', id: any, surname?: string | null, givenName?: string | null, dateOfBirth?: any | null, dateOfExpiry?: any | null, dateOfArrival?: any | null, address?: string | null, nationality?: string | null, documentNumber?: string | null, documentType?: string | null, email?: string | null, checkinNumber?: string | null, uploadedFrontPagePath?: string | null, uploadedBackPagePath?: string | null, frontPageType?: string | null, backPageType?: string | null, isConfirmed: boolean, isOcrDone: boolean, isScanDone: boolean };

export type CheckininsertMutationVariables = Exact<{
  object: Checkin_Insert_Input;
}>;


export type CheckininsertMutation = { __typename?: 'mutation_root', insertCheckin?: { __typename?: 'checkin', checkinCustomers: Array<{ __typename?: 'checkinCustomer', id: any, checkinId?: any | null }> } | null };

export type UpdateCheckinCustomerMutationVariables = Exact<{
  id: Scalars['uuid'];
  object: CheckinCustomer_Set_Input;
}>;


export type UpdateCheckinCustomerMutation = { __typename?: 'mutation_root', updateCheckinCustomer?: { __typename?: 'checkinCustomer', id: any } | null };

export type InsertCheckinFieldsFragment = { __typename?: 'checkin', checkinCustomers: Array<{ __typename?: 'checkinCustomer', id: any, checkinId?: any | null }> };

export const GetSharedLinkFieldsFragmentDoc = gql`
    fragment GetSharedLinkFields on sharedLink {
  organization {
    id
    name
    email
  }
}
    `;
export const GetLastCustomerFieldsFragmentDoc = gql`
    fragment GetLastCustomerFields on checkinCustomer {
  id
  surname
  givenName
  dateOfBirth
  dateOfExpiry
  dateOfArrival
  address
  nationality
  documentNumber
  documentType
  email
  checkinNumber
  uploadedFrontPagePath
  uploadedBackPagePath
  frontPageType
  backPageType
  isConfirmed
  isOcrDone
  isScanDone
}
    `;
export const InsertCheckinFieldsFragmentDoc = gql`
    fragment InsertCheckinFields on checkin {
  checkinCustomers {
    id
    checkinId
  }
}
    `;
export const GetSharedLinkDocument = gql`
    query GetSharedLink($hash: String!) {
  sharedLinks(where: {hash: {_eq: $hash}}) {
    ...GetSharedLinkFields
  }
}
    ${GetSharedLinkFieldsFragmentDoc}`;

export function useGetSharedLinkQuery(options: Omit<Urql.UseQueryArgs<GetSharedLinkQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSharedLinkQuery>({ query: GetSharedLinkDocument, ...options });
};
export const GetLastCustomerDocument = gql`
    subscription GetLastCustomer($customerId: uuid!) {
  checkinCustomer(id: $customerId) {
    ...GetLastCustomerFields
  }
}
    ${GetLastCustomerFieldsFragmentDoc}`;

export function useGetLastCustomerSubscription<TData = GetLastCustomerSubscription>(options: Omit<Urql.UseSubscriptionArgs<GetLastCustomerSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<GetLastCustomerSubscription, TData>) {
  return Urql.useSubscription<GetLastCustomerSubscription, TData, GetLastCustomerSubscriptionVariables>({ query: GetLastCustomerDocument, ...options }, handler);
};
export const CheckininsertDocument = gql`
    mutation Checkininsert($object: checkin_insert_input!) {
  insertCheckin(object: $object) {
    ...InsertCheckinFields
  }
}
    ${InsertCheckinFieldsFragmentDoc}`;

export function useCheckininsertMutation() {
  return Urql.useMutation<CheckininsertMutation, CheckininsertMutationVariables>(CheckininsertDocument);
};
export const UpdateCheckinCustomerDocument = gql`
    mutation UpdateCheckinCustomer($id: uuid!, $object: checkinCustomer_set_input!) {
  updateCheckinCustomer(pk_columns: {id: $id}, _set: $object) {
    id
  }
}
    `;

export function useUpdateCheckinCustomerMutation() {
  return Urql.useMutation<UpdateCheckinCustomerMutation, UpdateCheckinCustomerMutationVariables>(UpdateCheckinCustomerDocument);
};